import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  zh: {
    common: {
      fetchFailed: '获取数据失败',
      submitFailed: '提交失败',
      back: '返回',
      loading: '加载中...'
    },
    login: {
      title: '登录您的麦麦通账户',
      email: '邮箱',
      password: '请输入登陆密码（6-20位数字+字母组合）',
      captcha: '请输入验证码',
      refreshCaptcha: '点击刷新验证码',
      remember: '记住我',
      forgot: '忘记密码?',
      submit: '登录',
      register: '去注册',
      noAccount: '没有账户?',
      acquiringPlatform: '收单平台',
      enterEmail: '请输入邮箱地址',
      emailInvalid: '邮箱格式不正确，请输入有效的邮箱地址',
      enterPassword: '请输入密码',
      enterCaptcha: '请输入验证码',
      loginSuccess: '登录成功',
      loginFailed: '登录失败',
      loggingIn: '登录中...'
    },
    register: {
      title: '创建您的 Paymmt 账户',
      hasAccount: '已有账户？',
      login: '登录',
      companyLocation: '公司总部所在地',
      email: '邮箱',
      verifyCode: '验证码',
      sendCode: '发送验证码',
      companyName: '公司全名',
      password: '请输入登陆密码（6-20位数字+字母组合）',
      confirmPassword: '请输入登陆密码（6-20位数字+字母组合）',
      agree: '我已阅读并同意',
      userAgreement: '用户协议',
      and: '和',
      privacyPolicy: '隐私政策',
      submit: '立即注册',
      selectLocation: '请选择公司总部所在地',
      enterEmail: '请输入邮箱',
      emailFormat: '请输入正确的邮箱地址',
      enterVerifyCode: '请输入验证码',
      enterCompanyName: '请输入公司全名',
      enterPassword: '请输入密码',
      passwordLength: '密码长度不能少于6位',
      agreeTerms: '请同意用户协议和隐私协议',
      passwordRequirements: '密码须满足以下条件',
      passwordLengthTip: '6-20个字符',
      passwordEnglishTip: '包含英文字符',
      passwordNumberTip: '包含数字',
      enterEmailFirst: '请先输入邮箱',
      emailInvalid: '邮箱格式不正确，请输入有效的邮箱地址',
      sending: '发送中...',
      codeSent: '验证码已发送到您的邮箱',
      registering: '注册中...',
      registerSuccess: '注册成功，请登录',
      registerFailed: '注册失败',
      mainlandChina: '中国大陆',
      hongKong: '中国香港',
      otherRegion: '其他国家/地区',
      chinese: '中文',
      english: 'English'
    },
    forgotPassword: {
      title: '重置密码',
      subtitle: '请输入您的邮箱地址，我们将发送验证码到您的邮箱',
      email: '邮箱',
      verifyCode: '验证码',
      sendCode: '发送验证码',
      newPassword: '请输入登陆密码（6-20位数字+字母组合）',
      confirmPassword: '请输入登陆密码（6-20位数字+字母组合）',
      submit: '重置密码',
      backToLogin: '返回登录',
      emailRequired: '请输入邮箱',
      emailInvalid: '请输入正确的邮箱地址',
      verifyCodeRequired: '请输入验证码',
      passwordRequired: '请输入新密码',
      passwordMin: '密码长度不能少于6位',
      confirmPasswordRequired: '请确认密码',
      passwordMismatch: '两次输入的密码不一致',
      codeSent: '验证码已发送',
      resetSuccess: '密码重置成功',
      passwordRequirements: '密码须满足以下条件',
      passwordLengthTip: '6-20个字符',
      passwordEnglishTip: '包含英文字符',
      passwordNumberTip: '包含数字'
    },
    sidebar: {
      dashboard: '平台首页',
      collection: '收款',
      tradeOrder: '贸易单',
      tradeCollection: '贸易收款单',
      exchange: '换汇',
      exchangeOrder: '换汇订单',
      foreignExchange: '外汇管理',
      foreignExchangeList: '外汇列表',
      settlement: '结汇',
      settlementOrder: '结汇订单',
      settlementWithdrawOrder: '结汇出款订单',
      settlementQuota: '结汇额度查询',
      loan: '出款',
      transferRemittance: '转账汇款',
      fundManagement: '资金管理',
      myWallet: '我的钱包',
      accountManagement: '账户管理',
      foreignTradeAccount: '外贸收款账户',
      rmbSettlementAccount: '人民币结汇提现账户',
      overseasRemittanceAccount: '境外汇款账户',
      my: '我的',
      announcementList: '公告列表',
      enterpriseCertification: '企业认证',
      accountSecurity: '账号与安全',
      roleManagement: '角色管理',
      operatorManagement: '操作员管理',
      keyManagement: '公私钥管理'
    },
    header: {
      company: 'Hong Kong Techwin Co., Limited'
    },
    dashboard: {
      title: '资产概览',
      pending: '待办事项',
      exchangeRate: '交易参考牌价',
      bankHoliday: '银行假期日历',
      attention: '关注币种',
      totalAssets: '总资产',
      collection: '收款',
      exchange: '换汇',
      selectedDate: '选中日期',
      noHoliday: '该日期暂无节日信息',
      selectCurrency: '选择源币种',
      enterAmount: '请输入金额'
    },
    language: {
      chinese: '中文',
      english: 'English'
    },
    userInfo: {
      merchantNo: '商户编号',
      merchantId: '商户编号',
      merchantName: '商户名称',
      operatorName: '操作员名称',
      loginEmail: '登陆邮箱',
      logout: '退出登录'
    },
    unavailable: {
      description: '该功能暂未开通，敬请期待！',
      back: '返回首页'
    },
    enterprise: {
      title: '企业认证',
      activateAccount: 'ACTIVATE YOUR ACCOUNT',
      beforeJoin: '商户入网成功后，方可进行相关业务服务！',
      afterJoin: '商户入网成功',
      addBasicInfo: '添加企业基本信息',
      addBusinessInfo: 'Add Business Information'
    },
    tradeOrder: {
      title: '贸易单',
      all: '全部',
      inCollection: '收款中',
      underReview: '审核中',
      completed: '收款完成',
      rejected: '已驳回',
      closed: '已关闭',
      approved: '进行中',
      create: '创建贸易单',
      createDate: '创建日期',
      collectionCurrency: '收款币种',
      buyerContract: '付款方英文名/合同编号',
      tradeType: '贸易类型',
      startTime: '起始时间',
      to: '至',
      endTime: '结束时间',
      selectCollectionCurrency: '请选择收款币种',
      enterBuyerContract: '请输入付款方英文名/合同编号',
      selectTradeType: '请选择贸易类型',
      search: '查询',
      download: '下载',
      contractNo: '合同编号',
      buyerName: '付款方英文名',
      tradeArea: '贸易地区',
      contractAmount: '合同金额',
      associatedAmount: '已关联金额',
      status: '状态',
      associationRatio: '关联比例',
      operation: '操作',
      detail: '详情',
      edit: '编辑',
      noData: '暂无数据',
      goodsTrade: '货物贸易',
      serviceTrade: '服务贸易'
    },
    createTradeOrder: {
      breadcrumb: '贸易单',
      createTitle: '创建贸易单',
      editTitle: '编辑贸易单',
      collectionInfo: '收款信息',
      paymentCurrency: '收款币种',
      selectPaymentCurrency: '请选择收款币种',
      tradeType: '贸易类型',
      goodsTrade: '货物贸易',
      serviceTrade: '服务贸易',
      tradeMaterials: '贸易材料',
      materialNote: '注意：CONTRACT 和 PI/CI 类型文件不能同时为空',
      contractFile: '合同',
      contractUploadTip: '请上传合同。支持JPG、JPEG、PNG、PDF格式，最多上传5个文件，单个文件小于20MB',
      piCiFile: 'PI/CI',
      piCiUploadTip: '请上传CI或PI，至少上传一项。支持JPG、JPEG、PNG、PDF格式，最多上传5个文件，单个文件小于20MB',
      proofMaterials: '证明材料',
      proofUploadTip: '一般贸易请上传物流单、或电商场景等场景请上传订单明细等相关材料。支持JPG、JPEG、PNG、PDF格式，最多上传5个文件，单个文件小于20MB',
      contractNo: '合同编号',
      enterContractNo: '请输入合同编号',
      contractAmount: '合同金额',
      enterContractAmount: '请输入合同金额',
      tradeCountry: '贸易国家/地区',
      selectTradeCountry: '请选择贸易国家/地区',
      buyerName: '付款方英文名',
      enterBuyerName: '请输入付款方英文名',
      sanctionNote: '制裁国家说明',
      sanctionTooltip: '选择打款属地。如从意大利打款欧元，则「付款国家」选择「意大利」',
      sanctionCountries: '注：阿富汗、阿尔巴尼亚、白俄罗斯、波斯尼亚和黑塞哥维那、中非共和国、古巴、刚果民主共和国 - 刚果（金）、埃塞俄比亚、海地、伊朗、伊拉克、黎巴嫩、利比亚、缅甸、尼加拉瓜、朝鲜、俄罗斯联邦、索马里、南苏丹、苏丹、叙利亚、乌克兰、委内瑞拉、也门、伊黎伊斯兰国（达伊什）和基地组织、塔利班、黑山、塞尔维亚、加沙地带、巴基斯坦，以上国家不能进行作业',
      saveDraft: '暂存为草稿',
      submit: '提交',
      submitting: '提交中...',
      draftSuccess: '暂存成功',
      submitConfirm: '确定要提交该贸易单吗？',
      confirmSubmit: '确认提交',
      confirm: '确定',
      cancel: '取消',
      submitSuccess: '提交成功',
      submitFail: '提交失败',
      uploadSuccess: '上传成功',
      uploadFail: '文件上传失败',
      fileSizeError: '文件大小不能超过20MB',
      proofContractEmpty: '证明性材料中PROOF_MATERIALS和CONTRACT不能同时为空',
      uploadAtLeastOne: '请至少上传一个证明文件',
      selectPaymentCurrencyRule: '请选择收款币种',
      selectTradeTypeRule: '请选择贸易类型',
      enterContractNoRule: '请输入合同编号',
      enterContractAmountRule: '请输入合同金额',
      amountFormatError: '请输入正确的金额格式，最多两位小数',
      selectTradeCountryRule: '请选择贸易国家/地区',
      enterBuyerNameRule: '请输入付款方英文名',
      selectTradeType: '请选择贸易类型',
      selectTradeTypePlaceholder: '请选择贸易类型',
      amountSuffix: '请输入合同金额',
      fetchFailed: '获取数据失败'
    },
    tradeReceipt: {
      title: '贸易收款单',
      all: '全部',
      pending: '待关联',
      rejected: '已驳回',
      processing: '处理中',
      success: '入账成功',
      fail: '失败',
      receiptDate: '到账日期',
      entryDate: '入账日期',
      payerKeyword: '付款方/收款账户/贸易收款单号',
      payerKeywordPlaceholder: '付款方/收款账户/贸易收款单号',
      startTime: '起始时间',
      to: '至',
      endTime: '结束时间',
      search: '查询',
      batchRelate: '批量关联订单',
      download: '下载',
      receiptNo: '贸易收款单号',
      receiptEntryDate: '到账日期/入账日期',
      payer: '付款方',
      paymentAmount: '付款金额',
      fee: '手续费',
      accountNo: '收款账户',
      tradeNo: '贸易单号',
      tradeAmount: '贸易金额',
      operation: '操作',
      status: '状态',
      noData: '暂无数据',
      detail: '详情',
      relate: '关联',
      cancel: '取消',
      confirmRelate: '确认关联',
      selectTradeNo: '请选择贸易单号',
      selectRowsWarning: '请选择待关联、失败或审核退回的贸易收款单',
      allLinkedWarning: '请为所有贸易收款单选择对应的贸易单号',
      relateSuccess: '批量关联成功',
      relateFail: '批量关联失败',
      downloadDev: '下载功能开发中'
    },
    exchangeOrder: {
      title: '发起换汇',
      sellAmount: '卖出金额',
      enterSellAmount: '请输入卖出金额',
      selectSellCurrency: '请选择卖出币种',
      availableBalance: '可用余额',
      fullExchange: '全额换汇',
      exchangeTime: '换汇操作时间',
      startTime: '起始时间',
      endTime: '结束时间',
      to: '至',
      beijingTime: '北京时间',
      buyAmount: '买入金额',
      enterBuyAmount: '请输入买入金额',
      selectBuyCurrency: '请选择买入币种',
      exchangeRate: '参考汇率',
      submitExchange: '提交换汇',
      recentOrders: '最近换汇订单',
      orderNo: '换汇订单号',
      createTime: '创建时间',
      sellAmountLabel: '卖出金额',
      buyAmountLabel: '买入金额',
      rate: '汇率',
      status: '状态',
      completeTime: '完成时间',
      moreOrders: '更多订单',
      enterSellAmountWarning: '请输入卖出金额',
      selectSellCurrencyWarning: '请选择卖出币种',
      selectBuyCurrencyWarning: '请选择买入币种',
      sameCurrencyWarning: '卖出币种和买入币种不能相同',
      exceedBalanceWarning: '卖出金额不能超过可用余额',
      cannotExchangeWarning: '暂时不能换汇请改日在提交',
      confirmExchange: '确认换汇',
      confirmExchangeText: '确定将',
      exchangeTo: '换汇为',
      success: '提交成功',
      fail: '提交失败',
      processing: '处理中',
      successStatus: '成功',
      failed: '失败',
      cancelled: '已取消'
    },
    transferRemittance: {
      title: '转账汇款',
      orderRecord: '订单记录',
      singleRemittance: '单笔汇款',
      multipleRemittance: '多笔汇款(仅支持同币种付款到个人)',
      platformTransfer: '转账给平台其他商户',
      selectPayee: '选择收款方',
      fillRemittanceInfo: '填写汇款信息',
      confirmRemittance: '汇款确认',
      whoToRemit: '您要汇款给谁？',
      searchAccount: '搜索您要汇款的账户名称或者银行账户号',
      addOverseasAccount: '添加境外汇款账户',
      next: '下一步',
      prev: '上一步',
      remitAmount: '汇款金额',
      enterRemitAmount: '请输入汇款金额',
      selectCurrency: '请选择币种',
      remitRemark: '汇款附言',
      enterRemark: '请输入汇款附言（选填）',
      fee: '手续费',
      noRemark: '无',
      confirmRemitBtn: '确认汇款',
      selectPayeeWarning: '请选择收款方',
      enterRemitAmountWarning: '请输入汇款金额',
      exceedBalanceWarning: '汇款金额不能超过可用余额',
      remitSuccess: '汇款提交成功',
      uploadTemplate: '请上传汇款模板',
      uploadOrDrag: '点击或拖拽上传汇款模板',
      excelFormat: '支持 Excel 格式文件',
      totalAmount: '共',
      totalUnit: '笔，累计金额',
      noData: '暂无数据',
      payeeName: '收款人账户名称',
      accountNumber: '账户号',
      bankName: '收款银行名称',
      amount: '收款金额',
      downloadTemplate: '下载批量汇款模板',
      uploadDev: '上传功能开发中',
      downloadTemplateDev: '下载模板功能开发中',
      selectMerchant: '您要转账给哪位商户？',
      searchMerchantCode: '搜索您要转账的其他商户的商户编号',
      transferAmount: '转账金额',
      enterTransferAmount: '请输入转账金额',
      transferRemark: '转账附言',
      enterTransferRemark: '请输入转账附言（选填）',
      confirmTransfer: '转账确认',
      merchantCode: '收款商户编号',
      confirmTransferBtn: '确认转账',
      enterMerchantCodeWarning: '请输入商户编号',
      enterTransferAmountWarning: '请输入转账金额',
      transferSuccess: '转账提交成功',
      all: '全部',
      processing: '处理中',
      reviewRejected: '审核退回',
      success: '成功',
      failed: '失败',
      completed: '已完成',
      cancelled: '已取消',
      deductCurrency: '扣款币种',
      selectDeductCurrency: '请选择扣款币种',
      receiveCurrency: '到账币种',
      selectReceiveCurrency: '请选择到账币种',
      orderNo: '订单编号',
      enterOrderNo: '请输入订单编号',
      orderTime: '订单时间',
      startTime: '起始时间',
      endTime: '结束时间',
      payoutType: '出款类型',
      selectPayoutType: '请选择出款类型',
      type1: '类型1',
      type2: '类型2',
      search: '查询',
      download: '下载',
      tradeTime: '交易时间',
      deductAmount: '扣款金额',
      receiveAmount: '到账金额',
      exchangeRate: '汇率',
      fee: '手续费',
      orderStatus: '订单状态',
      payee: '收款人',
      remittanceType: '汇款类型',
      operation: '操作',
      detail: '详情',
      fetchFail: '获取订单列表失败',
      exportDev: '导出功能开发中',
      copySuccess: '复制成功',
      detailDev: '查看详情功能开发中'
    },
    transferRemittanceOrderDetail: {
      breadcrumb: '转账汇款',
      detailTitle: '汇款订单详情',
      merchantOrderNo: '订单编号',
      orderNo: '订单编号',
      sellCurrency: '卖出币种',
      sellAmount: '卖出金额',
      buyCurrency: '买入币种',
      buyAmount: '买入金额',
      merchantBidPrice: '商户出价',
      merchantFee: '手续费',
      payeeType: '收款方类型',
      orderStatus: '订单状态',
      createTime: '创建时间',
      completeTime: '完成时间',
      name: '收款人名称',
      accountNumber: '收款账号',
      country: '国家',
      subjectType: '汇款对象类型',
      reference: '参考号',
      feeBearer: '手续费承担方',
      failReason: '失败原因',
      back: '返回',
      missingId: '缺少订单ID',
      fetchFailed: '获取详情失败',
      payeeTypeOther: '其他服务',
      payeeTypePlatform: '平台商户',
      payeeTypeOverseas: '境外账户',
      subjectPrivate: '对私',
      subjectCompany: '对公',
      feeBearerOur: '汇款人承担',
      feeBearerSha: '共同承担',
      feeBearerBen: '收款人承担'
    },
    remittanceApply: {
      breadcrumb: '转账汇款',
      fillRemittanceInfo: '填写汇款信息',
      basicInfo: '基本信息',
      sellCurrency: '卖出币种',
      selectSellCurrency: '请选择卖出币种',
      buyCurrency: '买入币种',
      selectBuyCurrency: '请选择买入币种',
      sellAmount: '卖出金额',
      buyAmount: '买入金额',
      enterSellAmount: '请输入卖出金额',
      amountPlaceholder: '卖出金额、买入金额任选其一',
      amountValidator: '卖出金额、买入金额任选其一',
      availableBalance: '可用余额',
      remittanceType: '汇款类型',
      selectRemittanceType: '请选择汇款类型',
      logistics: '物流商',
      advertising: '广告商',
      supplier: '供货商',
      withdraw: '提现',
      travel: '旅行',
      infoService: '信息服务费',
      otherExpense: '其他支出',
      salary: '工资或佣金支付',
      feeServices: '费用',
      refund: '退汇',
      feeBearer: '手续费承担方式',
      selectFeeBearer: '请选择手续费承担方式',
      sha: 'SHA（共同承担）',
      our: 'OUR（付款方承担）',
      feeBearerTip: '仅买入币种为 USD、CNH、EUR、GBP 时生效',
      feeBearerDesc: 'SHA：SWIFT 电汇费用由您与收款方共同承担；OUR：您将承担全部费用，收款方全额到账',
      quoteId: '牌价引用ID',
      quoteIdPlaceholder: '卖出币种与买入币种不同时必填',
      reference: '汇款附言',
      enterReference: '请输入汇款附言',
      sameName: '是否同名出款',
      yes: '是',
      no: '否',
      fastArrival: '是否极速到账',
      fastArrivalTip: '极速到账作业时间：非节假日00:00-16:00(北京时间)',
      payeeInfo: '收款方信息',
      payeeAccountType: '收款账户类型',
      selectPayeeAccountType: '请选择收款账户类型',
      b2b: 'B2B对公',
      b2c: 'B2C对私',
      payeeAccountNumber: '收款账户号',
      enterPayeeAccountNumber: '请输入收款账户号',
      payeeAccountName: '收款账户名称',
      enterPayeeAccountName: '请输入收款账户名称',
      payeeCountry: '收款人国家',
      selectPayeeCountry: '请选择收款人国家',
      payeeAddress: '收款人地址',
      enterPayeeAddress: '请输入收款人地址',
      firstName: 'FirstName',
      firstNamePlaceholder: 'B2C对私必填',
      lastName: 'LastName',
      lastNamePlaceholder: 'B2C对私必填',
      payeePhone: '收款人手机号',
      phonePlaceholder: '汇款印尼时必填',
      payeeIdCard: '收款人证件号',
      enterPayeeIdCard: '请输入收款人证件号',
      bankCode: '开户银行编码',
      bankCodePlaceholder: '买入币种非USD时必填',
      bankName: '开户行名称',
      bankNamePlaceholder: '买入币种为USD时必填',
      bankCountry: '开户银行国家',
      selectBankCountry: '请选择开户银行国家',
      bankAddress: '开户银行地址',
      enterBankAddress: '请输入开户银行地址',
      swiftCode: 'Swift Code',
      enterSwiftCode: '请输入Swift Code',
      iban: 'IBAN',
      ibanPlaceholder: '欧盟地区银行账户必填',
      sortCode: 'Sort Code',
      sortCodePlaceholder: '英国银行账户必填',
      bsbNumber: 'BSB Number',
      bsbPlaceholder: '澳大利亚银行账户必填',
      postCode: 'Post Code',
      postCodePlaceholder: '美国银行账户必填',
      routingNumber: 'Routing Number',
      enterRoutingNumber: '请输入Routing Number',
      lineNumber: '联行号',
      enterLineNumber: '请输入联行号',
      voucherFiles: '凭证文件',
      voucherFilesHint: '若对私汇款,Invoice和合同文件二选一，若对公汇款都必传',
      invoiceFiles: 'Invoice文件',
      contractFiles: '合同文件',
      uploadTip: '支持JPG、JPEG、PNG、PDF格式，最多上传5个文件，单个文件小于20MB',
      uploading: '上传中',
      fileValidator: 'Invoice文件和合同文件二选一，至少上传一种',
      prevStep: '上一步',
      nextStep: '下一步：汇款确认',
      uploadSuccess: '上传成功',
      uploadFailed: '文件上传失败',
      fetchCurrencyFailed: '获取币种列表失败',
      fetchCountryFailed: '获取国家列表失败',
      fetchAccountFailed: '获取收款方信息失败',
      sellCurrencyRequired: '请选择卖出币种',
      buyCurrencyRequired: '请选择买入币种',
      remittanceTypeRequired: '请选择汇款类型',
      feeBearerRequired: '请选择手续费承担方式',
      payeeAccountTypeRequired: '请选择收款账户类型',
      payeeAccountNumberRequired: '请输入收款账户号',
      payeeAccountNameRequired: '请输入收款账户名称',
      payeeCountryRequired: '请选择收款人国家',
      payeeAddressRequired: '请输入收款人地址',
      bankCountryRequired: '请选择开户银行国家'
    },
    remittanceConfirm: {
      title: '汇款确认',
      basicInfo: '基本信息',
      sellCurrency: '卖出币种',
      buyCurrency: '买入币种',
      sellAmount: '卖出金额',
      buyAmount: '买入金额',
      remittanceType: '汇款类型',
      feeBearer: '手续费承担方式',
      quoteId: '牌价引用ID',
      reference: '汇款附言',
      sameName: '是否同名出款',
      fastArrival: '是否极速到账',
      yes: '是',
      no: '否',
      payeeInfo: '收款方信息',
      payeeAccountType: '收款账户类型',
      payeeAccountNumber: '收款账户号',
      payeeAccountName: '收款账户名称',
      payeeCountry: '收款人国家',
      payeeAddress: '收款人地址',
      firstName: 'FirstName',
      lastName: 'LastName',
      payeePhone: '收款人手机号',
      payeeIdCard: '收款人证件号',
      bankCode: '开户银行编码',
      bankName: '开户行名称',
      bankCountry: '开户银行国家',
      bankAddress: '开户银行地址',
      swiftCode: 'Swift Code',
      iban: 'IBAN',
      sortCode: 'Sort Code',
      bsbNumber: 'BSB Number',
      postCode: 'Post Code',
      routingNumber: 'Routing Number',
      lineNumber: '联行号',
      voucherFiles: '凭证文件',
      invoiceFiles: 'Invoice文件',
      contractFiles: '合同文件',
      download: '下载',
      prevStep: '上一步',
      confirmRemit: '确认汇款',
      noDataWarning: '未找到汇款信息，请重新填写',
      submitSuccess: '汇款申请已提交',
      submitFailed: '汇款提交失败',
      b2b: 'B2B对公',
      b2c: 'B2C对私',
      logistics: '物流商',
      advertising: '广告商',
      supplier: '供货商',
      withdraw: '提现',
      travel: '旅行',
      infoService: '信息服务费',
      otherExpense: '其他支出',
      salary: '工资或佣金支付',
      feeServices: '费用',
      refund: '退汇'
    },
    myWallet: {
      title: '我的资金',
      totalBalanceLabel: '当前各个币种总余额估值',
      currency: '币种',
      availableBalance: '可用余额',
      operation: '操作',
      exchange: '换汇',
      fundFlow: '资金流水',
      noData: '暂无数据',
      fetchFailed: '获取钱包数据失败'
    },
    fundFlow: {
      title: '资金流水',
      currency: '币种',
      select: '请选择',
      capitalDirection: '资金方向',
      increase: '收入',
      decrease: '支出',
      businessType: '业务类型',
      receipt: '收款',
      remittance: '汇款',
      exchange: '换汇',
      transfer: '转账',
      withdraw: '提现',
      tradeTime: '交易时间',
      startTime: '起始时间',
      endTime: '结束时间',
      to: '至',
      search: '查询',
      download: '下载',
      transactionAmount: '交易金额',
      postBalance: '交易后余额',
      operation: '操作',
      detail: '详情',
      downloadDev: '下载功能开发中',
      detailDev: '查看详情功能开发中'
    },
    digitalAccount: {
      title: '数字货币/数字资产',
      totalAssetLabel: '换算后加密资产总额',
      deposit: '充值',
      withdraw: '提现',
      exchange: '兑换',
      walletManage: '钱包管理',
      accountList: '账户列表',
      transactionDetails: '交易明细',
      depositRecords: '充值记录',
      withdrawRecords: '提现记录',
      currency: '币种',
      balance: '余额',
      value: '价值',
      assetProportion: '资产占比',
      noData: '暂无数据',
      transactionId: '交易编号',
      enterTransactionId: '请输入交易编号',
      transactionType: '交易类型',
      selectTransactionType: '请选择交易类型',
      typeDeposit: '入金',
      typeWithdraw: '提现',
      typeTransferOut: '汇出',
      typeTransferIn: '汇入',
      typeInviteReward: '邀请返',
      transactionTime: '交易时间',
      startDate: '开始日期',
      endDate: '结束日期',
      search: '搜索',
      transactionBalance: '交易金额',
      transactionFee: '交易手续费',
      transactionStatus: '交易状态',
      statusSuccess: '成功',
      statusFailed: '失败',
      remark: '备注',
      noRemark: '暂无备注',
      operation: '操作',
      detail: '详情',
      status: '状态',
      selectStatus: '请选择状态',
      statusRejected: '已拒绝',
      statusCompleted: '已完成',
      statusPending: '待审核',
      depositAmount: '入金额',
      fee: '手续费',
      feeRate: '手续费率',
      actualAmount: '实际到账金额',
      depositCurrency: '入金币种',
      depositStatus: '入金状态',
      depositProof: '入金凭证',
      loadFailed: '加载失败',
      depositTime: '入金时间',
      walletAddress: '钱包地址',
      withdrawAmount: '提现金额',
      combinedFee: '手续费',
      withdrawCurrency: '提现币种',
      statusApproved: '通过',
      statusCancelled: '取消',
      withdrawTime: '提现时间',
      transactionDetail: '交易详情',
      basicInfo: '基本信息',
      amountInfo: '金额信息',
      amount: '金额',
      fetchAccountListFailed: '获取账户列表失败',
      copySuccess: '复制成功',
      detailDev: '查看详情功能开发中'
    },
    digitalExchange: {
      title: '数字资产换汇',
      sell: '卖出',
      buy: '买入',
      availableBalance: '可用余额',
      enterQuantity: '请输入数量',
      autoCalculate: '自动计算',
      fee: '手续费',
      price: '价格',
      confirmTransaction: '确定兑换',
      exchanging: '兑换中...',
      return: '返回',
      fillCompleteInfo: '请填写完整信息',
      tradeSuccess: '交易成功',
      tradeFailed: '交易失败',
      fetchCurrencyFailed: '获取币种列表失败',
      fetchRateFailed: '获取汇率失败'
    },
    digitalWithdraw: {
      title: '转出',
      withdrawWallet: '转出钱包',
      selectWithdrawWallet: '请选择转出钱包',
      withdrawAddress: '转出区块链钱包地址',
      selectWithdrawAddress: '请选择转出地址',
      withdrawAmount: '转出金额',
      enterWithdrawAmount: '转出金额',
      withdrawAll: '全部转出',
      minAmount: '最低转出金额',
      availableBalance: '可用余额',
      combinedFee: '手续费',
      actualAmount: '实际到账金额',
      confirmWithdraw: '确认转出',
      selectWalletWarning: '请选择转出钱包',
      selectAddressWarning: '请选择转出地址',
      enterAmountWarning: '请输入转出金额',
      withdrawSuccess: '提现提交成功',
      withdrawFailed: '转出失败',
      fetchBalanceFailed: '获取余额失败',
      fetchWalletFailed: '获取钱包信息失败'
    },
    digitalWithdrawal: {
      title: '出入金账户管理',
      addWallet: '新增入金付款钱包',
      walletName: '钱包名称',
      walletAddress: '钱包地址',
      createTime: '建立时间',
      operate: '操作',
      delete: '删除',
      enterWalletName: '请输入钱包名称',
      enterWalletAddress: '请输入钱包地址',
      cancel: '取消',
      confirm: '确定',
      addSuccess: '新增成功',
      addFailed: '新增失败',
      deleteConfirm: '确认删除该钱包？',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      fetchWalletFailed: '获取钱包列表失败',
      copySuccess: '复制成功'
    },
    digitalDeposit: {
      title: '充值',
      depositMethod: '充值方式',
      selectDepositMethod: '请选择充值方式',
      normalDeposit: '普通入金',
      blockchainNetwork: '区块链网络',
      selectNetwork: '请选择区块链网络',
      depositTo: '入金到',
      selectCurrency: '请选择币种',
      copyAddress: '请复制下述地址信息，向您的钱包充值',
      copy: '复制',
      noAddress: '暂无可复制的地址',
      rechargeAmount: '充值金额',
      enterRechargeAmount: '请输入充值金额',
      tradeId: '交易号',
      enterTradeId: '请输入交易号',
      uploadScreenshot: '上传银行转账截图',
      warning1: '*请务必确保您所使用的钱包地址正确无误，如转账地址错误，您的资金可能会永久遗失，无法追回。',
      warning2: '*请务必确保您的充值币种为USDC 向此地址转入其他币种，您的资金可能会永久遗失，无法追回。',
      fee: '手续费',
      actualAmount: '实际到账金额',
      confirmDeposit: '确定充值',
      minAmount: '最低充值金额',
      enterAmountWarning: '请输入充值金额',
      enterTradeIdWarning: '请输入交易号',
      uploadScreenshotWarning: '请上传银行转账截图',
      depositSuccess: '充值提交成功',
      depositFailed: '充值失败',
      copySuccess: '复制成功'
    },
    foreignTradeAccount: {
      title: '外贸收款账户',
      apply: '申请外贸收款账户',
      globalTab: '多币种全球收款账户',
      localTab: '本地收款账户',
      hideUnavailable: '只看可用账户',
      globalAccount: '全球收款账户',
      localAccount: '本地收款账户',
      noAccount: '暂无收款账户',
      accountNotice: '账户使用须知',
      scopeLimitTitle: '1. 使用范围限制',
      scopeLimitContent: '本账户仅限企业间贸易（B2B）用途，另请打款前提前与您的买家确认商业背景信息，建议您的买家尽量使用对公账户汇出资金，并附言清晰（含PI编号，产品信息，买家信息等）。另纯个人采购付款会存在资金退回风险，望知悉。',
      geoLimitTitle: '2. 地域与机构限制',
      bannedAreas: '禁收区域',
      bannedAreasContent: '俄罗斯、白俄罗斯、叙利亚、缅甸、阿富汗、朝鲜、伊朗、古巴、刚果（金）、克里米亚、加沙地带、巴勒斯坦约旦河西岸地区，以及乌克兰的顿涅茨克、卢甘斯克、赫尔松、扎波罗热地区；',
      freightLimit: '货运限制',
      freightLimitContent: '避免使用受国际制裁的货运公司承运货物；',
      bankLimit: '银行限制',
      bankLimitContent: '涉及制裁名单内的金融机构（含所有币种）均不予接收。',
      auditTitle: '3. 资金审核权责',
      auditContent: '我方与银行保留对入账资金的审查权限，用户需配合提交资金来源证明文件（如合同、发票、物流单据等）；审核通过后可正常结算，若存疑则有权冻结或退回资金；',
      thirdPartyTitle: '第三方代付要求',
      thirdPartyContent: '若付款方非签约采购主体（如采购方为A公司，实际付款方为B公司），需提供A与B的关联证明文件，包括但不限于：股权架构证明、委托代付协议、代采购服务协议等法律文件。',
      globalDesc: '全球200+地区收款(非制裁地区);支持14+主流币种收款，支持企业英文名称作为开户名',
      localDesc: '本地收款超便捷，快至秒级到账中间行手续费低至0',
      openingArea: '开户地区',
      searchArea: '搜索开户地区',
      search: '查询',
      reset: '重置',
      applyBtn: '申请',
      applyCollectionAccount: '申请收款账户',
      payeeAccount: '收款人账户',
      fetchFailed: '获取账户列表失败',
      statusDeal: '申请中',
      statusSuccess: '已通过',
      statusReject: '已拒绝',
      statusVerifyBack: '已退回'
    },
    applyForeignTradeAccount: {
      title: '申请收款账户',
      accountType: '收款账户类型',
      globalAccountTitle: '多币种全球收款账户',
      globalAccountDesc: '支持全球主要币种收付款，资金直接入账',
      localAccountTitle: '本地收款账户',
      localAccountDesc: '支持特定国家/地区本地银行账户收款',
      openingArea: '开户地区',
      searchArea: '搜索开户地区',
      search: '查询',
      reset: '重置',
      noRegionFound: '未找到匹配的地区',
      bankList: '开户银行',
      receivingArea: '收款地区',
      receivingMethod: '收款方式',
      transactionLimit: '交易限额',
      accountName: '开户名称',
      openingTime: '开户时效',
      receivingCurrency: '收款币种',
      bankCountry: '国家',
      bankCurrency: '币种',
      productType: '产品类型细分',
      businessType: '可作业类型',
      paymentMethod: '收款方式 - 支持网络',
      accountPayType: '收款方式 - 公/私户付款',
      nameRequirement: 'VA规则 VA是否同名',
      limitInfo: '收款限额 - 单笔\\每日',
      bankCode: '银行代码',
      swift: 'SWIFT',
      currency: '币种',
      accountTypeLabel: '账户类型',
      noData: '暂无数据',
      offlineNotice: '如需办理本地区收款，请线下联系我司运营人员。',
      nar1Title: '周年申报表（NAR1）',
      nar1UploadTip: '请上传周年申报表（NAR1），有利于加快审核速度。支持 JPG、JPEG、PNG、PDF四种格式，最多上传1个，单个文件限制20MB',
      dragUpload: '点击上传，或将上传的文件拖至此处',
      materialTitle: '其他补充资料',
      materialTooltip: '请上传其他补充资料，有利于加快审核速度。支持 JPG、JPEG、PNG、PDF四种格式，最多上传10个，单个文件限制20MB',
      back: '返回',
      apply: '申请',
      accountNotice: '账户使用须知',
      scopeLimitTitle: '1. 使用范围限制',
      scopeLimitContent: '本账户仅限企业间贸易（B2B）用途，另请打款前提前与您的买家确认商业背景信息，建议您的买家尽量使用对公账户汇出资金，并附言清晰（含PI编号，产品信息，买家信息等）。另纯个人采购付款会存在资金退回风险，望知悉。',
      geoLimitTitle: '2. 地域与机构限制',
      bannedAreas: '禁收区域',
      bannedAreasContent: '俄罗斯、白俄罗斯、叙利亚、缅甸、阿富汗、朝鲜、伊朗、古巴、刚果（金）、克里米亚、加沙地带、巴勒斯坦约旦河西岸地区，以及乌克兰的顿涅茨克、卢甘斯克、赫尔松、扎波罗热地区；',
      freightLimit: '货运限制',
      freightLimitContent: '避免使用受国际制裁的货运公司承运货物；',
      bankLimit: '银行限制',
      bankLimitContent: '涉及制裁名单内的金融机构（含所有币种）均不予接收。',
      auditTitle: '3. 资金审核权责',
      auditContent: '我方与银行保留对入账资金的审查权限，用户需配合提交资金来源证明文件（如合同、发票、物流单据等）；审核通过后可正常结算，若存疑则有权冻结或退回资金；',
      thirdPartyTitle: '第三方代付要求',
      thirdPartyContent: '若付款方非签约采购主体（如采购方为A公司，实际付款方为B公司），需提供A与B的关联证明文件，包括但不限于：股权架构证明、委托代付协议、代采购服务协议等法律文件。',
      selectRegionWarning: '请选择开户区域',
      fetchCountryFailed: '获取国家列表失败',
      searchSuccess: '查询成功',
      selectAccountTypeWarning: '请选择收款账户类型',
      confirmSubmit: '确定要提交该申请吗？',
      confirmTitle: '确认申请',
      confirm: '确定',
      cancel: '取消',
      submitSuccess: '申请提交成功，审核周期通常为1-3个工作日',
      submitFailed: '申请提交失败',
      uploading: '上传中'
    },
    foreignTradeAccountDetail: {
      title: '收款账户详情',
      globalAccount: '多币种全球收款账户',
      localAccount: '本地收款账户',
      applyTime: '申请时间',
      openTime: '开通时间',
      initiatePayment: '发起收款',
      copyAccountInfo: '复制账户信息',
      downloadAccountInfo: '下载账户信息',
      capacityAccount: '账户能力',
      receivingArea: '收款地区',
      receivingMethod: '收款方式',
      transactionLimit: '交易限额',
      receivingCurrency: '收款币种',
      accountInfo: '账户信息',
      accountNo: '账户号码',
      accountName: '账户名称',
      bankName: '银行名称',
      countryRegion: '账户所在国家/地区',
      swiftCode: 'Swift Code',
      bankAddress: '银行地址',
      iban: 'IBAN',
      bsbNumber: 'BSB Number',
      branchBankName: '支行名称',
      branchBankCode: '支行代码',
      accountNotice: '账户使用须知',
      scopeLimitTitle: '1. 使用范围限制',
      scopeLimitContent: '本账户仅限企业间贸易（B2B）用途，另请打款前提前与您的买家确认商业背景信息，建议您的买家尽量使用对公账户汇出资金，并附言清晰（含PI编号，产品信息，买家信息等）。另纯个人采购付款会存在资金退回风险，望知悉。',
      geoLimitTitle: '2. 地域与机构限制',
      bannedAreas: '禁收区域',
      bannedAreasContent: '俄罗斯、白俄罗斯、叙利亚、缅甸、阿富汗、朝鲜、伊朗、古巴、刚果（金）、克里米亚、加沙地带、巴勒斯坦约旦河西岸地区，以及乌克兰的顿涅茨克、卢甘斯克、赫尔松、扎波罗热地区；',
      freightLimit: '货运限制',
      freightLimitContent: '避免使用受国际制裁的货运公司承运货物；',
      bankLimit: '银行限制',
      bankLimitContent: '涉及制裁名单内的金融机构（含所有币种）均不予接收。',
      auditTitle: '3. 资金审核权责',
      auditContent: '我方与银行保留对入账资金的审查权限，用户需配合提交资金来源证明文件（如合同、发票、物流单据等）；审核通过后可正常结算，若存疑则有权冻结或退回资金；',
      thirdPartyTitle: '第三方代付要求',
      thirdPartyContent: '若付款方非签约采购主体（如采购方为A公司，实际付款方为B公司），需提供A与B的关联证明文件，包括但不限于：股权架构证明、委托代付协议、代采购服务协议等法律文件。',
      loading: '加载中...',
      missingId: '缺少账户ID',
      fetchFailed: '获取账户详情失败',
      copySuccess: '账户信息已复制到剪贴板',
      downloadSuccess: '账户信息已下载',
      statusDeal: '申请中',
      statusSuccess: '已开通',
      statusReject: '已拒绝',
      statusVerifyBack: '已退回'
    },
    overseasRemittance: {
      title: '境外汇款账户',
      addAccount: '添加境外汇款账户',
      enterpriseAccount: '本企业账户',
      supplierAccount: '供应商账户',
      accountType: '账户类型',
      selectAccountType: '请选择账户类型',
      status: '状态',
      selectStatus: '请选择状态',
      accountNameOrNumber: '账户名称或账户号',
      enterAccountNameOrNumber: '请输入账户名称或账户号',
      search: '查询',
      reset: '重置',
      payeeAccountName: '收款人账户名称',
      accountNumber: '账户号',
      accountTypeLabel: '账户类型',
      currency: '币种',
      bankName: '银行名称',
      statusLabel: '状态',
      rejectReason: '退回原因',
      operation: '操作',
      viewDetail: '详情',
      edit: '编辑',
      reapply: '重新提交',
      noData: '暂无数据',
      companyAccount: '企业账户',
      personalAccount: '个人账户',
      statusReviewing: '审核中',
      statusRejected: '审核退回',
      statusInUse: '使用中',
      statusClosed: '已关闭',
      statusFrozen: '冻结中',
      enterprise: '企业',
      personal: '个人',
      accountBelong: '账户所属',
      supplier: '供应商账户',
      accountTypeTitle: '账户类型',
      company: '企业账户',
      personalAccount2: '个人账户',
      legalPerson: '企业法人/股东',
      employee: '企业员工',
      accountInfo: '账户信息',
      bankRegion: '开户银行地区',
      selectBankRegion: '请选择开户银行地区',
      bankAccountName: '银行账户名称',
      enterBankAccountName: '请输入银行账户名称',
      bankNameLabel: '银行名称',
      enterBankName: '请输入银行名称',
      accountCurrency: '账户币种',
      selectAccountCurrency: '请选择账户币种',
      bankAccountNumber: '银行账户号',
      enterBankAccountNumber: '请输入银行账户号',
      swiftCode: 'swiftCode/BIC',
      enterSwiftCode: '请输入swiftCode/BIC',
      bankAddress: '银行地址',
      enterBankAddress: '请输入银行地址',
      bankAddressTip: '请填写完整的银行英文地址，如果填写不完整，可能导致出款失败',
      return: '返回',
      apply: '申请',
      submitSuccess: '申请提交成功',
      submitting: '提交中...'
    },
    rmbSettlement: {
      title: '人民币结汇提现账户',
      addAccount: '添加结汇提现账户',
      editAccount: '编辑结汇提现账户',
      enterpriseAccount: '本企业账户',
      supplierAccount: '供应商账户',
      enterpriseAccountDesc: '账户名为本公司企业中文名称或者企业法人、董事、股东的个人账户',
      supplierAccountDesc: '用于企业、个人供应商或相关商业合作伙伴的结汇',
      accountType: '账户类型',
      selectAccountType: '请选择',
      status: '状态',
      selectStatus: '请选择状态',
      accountNameOrNumber: '账户名称或账号',
      enterAccountNameOrNumber: '请输入账户名称或账号',
      search: '查询',
      payeeAccountName: '收款人账户名称',
      accountNumber: '账户号',
      accountTypeLabel: '账户类型',
      bankName: '银行名称',
      statusLabel: '状态',
      rejectReason: '退回原因',
      operation: '操作',
      view: '查看',
      edit: '编辑',
      noData: '暂无数据',
      personalAccount: '个人账户',
      companyAccount: '企业账户',
      statusReviewing: '审核中',
      statusInUse: '使用中',
      statusRejected: '审核退回',
      statusClosed: '已关闭',
      // 详情/新增页面共用
      detail: '账户详情',
      accountBelong: '账户所属',
      legalPerson: '企业法人/股东',
      employee: '企业员工',
      accountInfo: '账户信息',
      bankAccountNumber: '银行账户号',
      enterBankAccountNumber: '请输入银行账户号',
      accountNumberFormat: '格式：6222000000000000000',
      accountNumberFormatEditSuffix: '，一旦创建不支持修改',
      bankNameLabel: '银行名称',
      enterBankName: '请输入银行名称',
      auditStatus: '审核状态',
      returnReason: '退回原因',
      createdAt: '创建时间',
      auditedAt: '审核时间',
      branchName: '支行名称',
      enterBranchName: '请输入支行名称',
      cnapsCode: '联行号',
      enterCnapsCode: '请输入联行号',
      back: '返回',
      // 新增页面专属
      singleSubmit: '单个提交',
      batchSubmit: '批量提交',
      cardholderName: '持卡人姓名',
      selectCardholderName: '请选择持卡人姓名',
      enterCardholderName: '请输入持卡人姓名',
      bankAccountName: '银行账户名称',
      enterBankAccountName: '请输入银行账户名称',
      enterpriseNameAuto: '企业名称由系统自动带入',
      orangeTipPersonal: '账户名称需要与个人证件名称一致',
      downloadTemplate: '下载批量导入模板',
      uploadDragText: '将文件拖到此处，或',
      uploadClickText: '点击上传',
      uploadHint: '仅支持 xls/xlsx 格式文件，单次最多上传 1 个文件',
      agreementPrefix: '本人已阅读并同意',
      agreementLink: '《授权承诺函》',
      agreementSuffix: '，确认已填写的信息均为真实、准确信息。',
      authorizationTitle: '授权承诺函',
      confirm: '确认',
      submit: '申请',
      submitting: '申请中...',
      // 校验提示
      ruleSelectCardholder: '请选择持卡人姓名',
      ruleEnterCardholder: '请输入持卡人姓名',
      ruleEnterAccountNumber: '请输入银行账户号',
      ruleEnterBankName: '请输入银行名称',
      ruleEnterAccountName: '请输入银行账户名称',
      ruleEnterBranchName: '请输入支行名称',
      ruleEnterCnapsCode: '请输入联行号',
      ruleBatchFileRequired: '请上传批量导入文件',
      ruleAgreementRequired: '请先阅读并同意《授权承诺函》',
      ruleExceedFileLimit: '单次最多上传 1 个文件，请先删除已上传文件',
      msgTemplateDeveloping: '模板下载功能开发中',
      msgSubmitSuccess: '申请提交成功',
      msgEditSuccess: '修改成功',
      msgLoadFailed: '加载详情失败',
      msgEnterpriseInfoFailed: '获取企业信息失败',
      msgSubmitFailed: '申请提交失败，请稍后再试',
      msgLoading: '加载中...',
      // 授权承诺函条款
      clause1: '授权结汇至我公司对公账户，或具备中国境内居民身份、且与我公司存在真实贸易关系的法定代表人、董事、股东个人账户；',
      clause2: '结汇至我公司境内采购代理人，我们承诺基于真实的贸易背景及采购代理关系，进行结汇操作，我公司确认并保证申报人为我公司境内采购代理人，我公司与其进行的款项结算为真实发生，我公司已取得申报人明确同意，授权我公司将其信息提交平台合作银行用于我公司与其结算款项的结汇申报，我公司已明确告知其授权我司提交的姓名、身份证号等个人信息将用于向中国外汇管理局进行申报，我公司进一步承诺及保证已获取授权人的同意及授权。',
      clause3: '我们确保使用结汇服务所提交的信息均获取了有效授权并持续在授权有效期内，如授权人员信息发生变更的，我们将在使用结汇服务及时修改、更正相关人员信息，我们理解并同意确保提交信息的真实性及有效性完全为我们的责任及义务，平台对此不承担任何法律责任。',
      clause4: '我们确保填写的收款信息准确，并进一步确认我们在结汇至供应商界面所填写的收款人信息及银行账户系我司供应商及其银行账户。如因信息错误导致收款失败或将结汇款项支付至错误账户的，由此产生的损失将由我们全部承担，平台对此不承担任何法律责任。',
      clause5: '我公司保证本承诺书所述之信息均真实有效，如我公司有虚假陈述或未取得有效授权的，我公司将承担一切法律责任，如因此给平台造成任何损失的，我公司将承担全部赔偿责任以确保平台免受任何损失。'
    },
    settlementOrder: {
      title: '结汇订单',
      createOrder: '创建结汇订单',
      // 状态 Tab
      tabAll: '全部',
      tabDealing: '结汇中',
      tabPartial: '部分成功',
      tabSuccess: '结汇完成',
      tabFailed: '失败',
      // 搜索表单
      orderNo: '结汇订单号',
      enterOrderNo: '请输入结汇订单号',
      createDate: '创建日期',
      completeDate: '完成日期',
      dateRangeSep: '至',
      startDate: '开始日期',
      endDate: '结束日期',
      settlementType: '结汇类型',
      selectSettlementType: '请选择',
      typeLabor: '劳务结汇',
      typeGoods: '货贸结汇',
      typeService: '服贸结汇',
      search: '查询',
      // 表格
      noData: '暂无数据',
      colOrderNo: '结汇订单号',
      colCreateTime: '创建时间',
      colPayCurrency: '付款币种',
      colSettlementAmount: '结汇金额',
      colFee: '手续费',
      colArrivalCurrency: '到账币种',
      colArrivalAmount: '结汇到账金额',
      colSettlementType: '结汇类型',
      colStatus: '状态',
      colRemark: '备注',
      colCompleteTime: '完成时间',
      colOperation: '操作',
      view: '查看',
      paymentDetail: '付款明细',
      // 抽屉详情
      detailTitle: '结汇订单详情',
      merchantOrderNo: '商户订单号',
      detailOrderNo: '结汇订单号',
      detailSettlementType: '结汇类型',
      detailStatus: '状态',
      detailPayCurrency: '付款币种',
      detailSettlementAmount: '结汇金额',
      detailArrivalCurrency: '到账币种',
      detailArrivalAmount: '结汇到账金额',
      detailFee: '手续费',
      detailRemark: '备注',
      detailCreateTime: '创建时间',
      detailCompleteTime: '完成时间',
      failReason: '失败原因',
      close: '关闭',
      // 状态映射
      statusInit: '待付款',
      statusDeal: '结汇中',
      statusVerifyBack: '审核退回',
      statusPart: '部分成功',
      statusSuccess: '结汇完成',
      statusFail: '失败',
      // 提示
      msgGetDetailFailed: '获取订单详情失败'
    },
    createSettlementOrder: {
      breadcrumbRoot: '结汇订单',
      title: '创建结汇订单',
      typeLaborTitle: '劳务款结汇',
      laborDesc1: '支持提现至大陆企业同名银行账户、法人代表、持股25%及以上股东、供应商及企业员工银行账户',
      laborDesc2: '结汇操作需提交结汇申报材料，该材料不得使用已被使用过的明细内容(含其他平台)',
      laborDesc3: '结汇费用为(结汇金额*手续费)，无其他费用',
      laborDesc4: '普通结汇：处理时间为下一个工作日（不包含香港、美国假期）9:00至16:00（北京时间）',
      laborDesc5: '极速结汇：处理时间为7*24小时',
      msgTypeDeveloping: '「{title}」创建功能开发中'
    },
    laborSettlement: {
      // 页面标题与面包屑
      pageTitle: '劳务款结汇',
      createOrderTitle: '创建结汇订单',
      orderRecordBtn: '结汇订单',
      // 步骤
      stepSelectAccount: '选择结汇账户',
      stepFillInfo: '填写结汇信息',
      stepConfirm: '结汇信息确认',
      // 选择账户页
      selectAccountQuestion: '请选择结汇账户（可多选）',
      emptyAccount: '暂无结汇账户数据',
      addRmbAccount: '添加人民币结汇账户',
      nextBtn: '下一步',
      prevBtn: '上一步',
      // 表格列
      colIndex: '序号',
      colAccountName: '账户名称',
      colAccountNo: '账户号',
      colBankName: '开户银行',
      colAccountType: '账户类型',
      colReceiptAmountCny: '收款金额（CNY）',
      colReferenceOptional: '附言（选填）',
      colReference: '附言',
      colPayeeName: '收款人姓名',
      colReceiptAccount: '收款账户',
      colReceiptAmount: '收款金额',
      colPayerName: '付款人姓名',
      colCertType: '证件类型',
      colCertNo: '证件号码',
      colBirthday: '出生日期',
      colRelation: '与收款人关系',
      // 账户类型
      accountTypePersonal: '个人账户',
      accountTypeEnterprise: '企业账户',
      // placeholder
      phReceiptAmount: '请输入收款金额',
      phReference: '请输入附言',
      phPayerName: '请输入付款人姓名',
      phCertType: '请选择证件类型',
      phCertNo: '请输入证件号码',
      phBirthday: '请选择出生日期',
      phRelation: '请选择关系',
      phCurrency: '请选择币种',
      phRemark: '请输入备注',
      phCaptcha: '请输入图形验证码',
      phEmailCode: '请输入邮箱验证码',
      // 表单 label
      labelPayerName: '付款人姓名',
      labelCertType: '证件类型',
      labelCertNo: '证件号码',
      labelBirthday: '出生日期',
      labelRelation: '与收款方关系',
      labelPlatformAccount: '付款平台账户',
      labelArrivalAmount: '结汇到账金额',
      labelRemark: '备注（选填）',
      // 证件类型
      certIdCard: '身份证',
      certPassport: '护照',
      // 与收款方关系
      relationSelf: '本人',
      relationSpouse: '配偶',
      relationParents: '父母',
      relationChildren: '子女',
      relationSiblings: '兄弟姐妹',
      relationPaternalGrandparents: '祖父母',
      relationMaternalGrandparents: '外祖父母',
      relationPaternalGrandchildren: '孙子女',
      relationMaternalGrandchildren: '外孙子女',
      relationEmployee: '雇员',
      relationNote: '收款人账户为银行卡时，只支持本人',
      // 区块标题
      payerInfoTitle: '付款人信息',
      payeeInfoTitle: '收款人信息',
      settlementInfoTitle: '结汇信息',
      tradeVerifyTitle: '交易验证',
      // 收款人 tab label
      payeeTabLabel: '收款人{idx}：{name}',
      // 余额与费用试算
      availableBalance: '可用余额：',
      rateLabelCurrent: '当前汇率：',
      rateLabelSettlement: '结汇金额：',
      rateLabelArrival: '结汇到账金额：',
      countdownExpired: '已过期',
      // 结汇信息描述
      descPayCurrency: '付款币种',
      descRate: '汇率',
      descSettlementAmount: '结汇金额',
      descArrivalAmount: '结汇到账金额',
      descRemark: '备注',
      // 验证码
      labelCaptcha: '图形验证码',
      labelEmailCode: '邮箱验证码',
      getCaptcha: '点击获取',
      getCode: '获取验证码',
      resendCode: '{sec}s后重发',
      // 提交按钮
      submitBtn: '提交',
      submittingBtn: '提交中...',
      // 校验与提示
      msgSelectAccount: '请至少选择一个结汇账户',
      msgInputReceiptAmount: '请输入{name}的收款金额',
      msgPayerNameRequired: '收款人{idx}：请填写付款人姓名',
      msgPayerCertTypeRequired: '收款人{idx}：请选择证件类型',
      msgPayerCertNoRequired: '收款人{idx}：请填写证件号码',
      msgPayerRelationRequired: '收款人{idx}：请选择与收款方关系',
      msgSelectCurrency: '请选择付款币种',
      msgSelectAccountFirst: '请先选择结汇账户',
      msgFillInfoFirst: '请先填写结汇信息',
      msgDataAbnormal: '数据异常，请重新填写',
      msgBalanceInsufficient: '平台账户余额不足，可用余额 {balance} {currency}',
      msgInputCaptchaFirst: '请先输入图形验证码',
      msgEmailCodeSent: '邮箱验证码已发送',
      msgInputCaptcha: '请输入图形验证码',
      msgInputEmailCode: '请输入邮箱验证码',
      msgSubmitLoading: '提交中...',
      msgSubmitSuccess: '订单提交成功',
      msgSubmitSuccessWithNo: '订单提交成功，订单号：{orderNo}',
      msgSubmitFailed: '提交失败，请稍后重试'
    },
    withdrawOrder: {
      // 页面标题与面包屑
      breadcrumbOrder: '结汇订单',
      pageTitle: '结汇出款订单',
      // 订单信息
      infoOrderNo: '结汇订单号：',
      infoMerchantOrderNo: '商户订单号：',
      infoOrderStatus: '订单状态：',
      // 状态 Tab
      tabAll: '全部',
      tabRemitInit: '待出款',
      tabRemitDeal: '出款中',
      tabRemitSuccess: '出款成功',
      tabReturned: '已退单',
      // 搜索表单
      filterOrderNo: '结汇订单号/出款订单号',
      filterAccountName: '收款账户名称',
      filterAccountNumber: '收款账号',
      filterSettlementType: '出款类型',
      filterCreateDate: '创建日期',
      filterCompleteDate: '完成日期',
      phInput: '请输入',
      phSelect: '请选择',
      dateRangeSep: '至',
      startPh: '起始时间',
      endPh: '结束时间',
      typeLabor: '劳务结汇',
      typeGoods: '货贸结汇',
      typeService: '服贸结汇',
      searchBtn: '查询',
      downloadBtn: '下载',
      // 表格
      noData: '暂无出款订单',
      colIndex: '序号',
      colMerchantRemitOrderNo: '商户出款订单号',
      colOrderNo: '结汇订单号',
      colAccountName: '收款账户名称',
      colAccountNumber: '收款账号',
      colBankName: '收款银行',
      colArrivalAmount: '结汇到账金额',
      colSettlementType: '出款类型',
      colStatus: '状态',
      colReference: '附言',
      colCreateTime: '创建时间',
      colCompleteTime: '完成时间',
      // 订单状态映射
      orderStatusInit: '待付款',
      orderStatusDeal: '结汇中',
      orderStatusVerifyBack: '审核退回',
      orderStatusPart: '部分成功',
      orderStatusSuccess: '结汇完成',
      orderStatusFail: '失败',
      // 出款状态映射
      remitStatusInit: '待出款',
      remitStatusDeal: '出款中',
      remitStatusSuccess: '出款成功',
      remitStatusReturned: '已退单',
      // 提示
      msgGetListFailed: '获取出款订单列表失败',
      msgDownloadPending: '下载接口待后台提供，导出参数与查询一致（page/page_size 除外）'
    },
    accountSecurity: {
      title: '账号与安全设置',
      bindPhone: '绑定手机',
      bindEmail: '绑定邮箱',
      updatePhone: '更换绑定手机',
      updateEmail: '更换绑定邮箱',
      loginPassword: '登录密码',
      passwordSet: '已设置',
      updatePassword: '修改登录密码',
      phoneComplianceTip: '为保证您的账户安全及符合银行合规要求，请确保手机号归属人是企业重要成员;重要成员包括: 法定代表人、实际控制人、占股超过25%的自然人股东，被授权人等。',
      originalPhone: '原手机号',
      newPhone: '新手机号',
      smsCode: '短信验证码',
      currentPassword: '当前登录密码',
      return: '返回',
      submit: '提交',
      verifyOriginalEmail: '验证原邮箱',
      bindNewEmail: '绑定新邮箱',
      confirmModify: '确认修改',
      emailComplianceTip: '为保证您的账户安全及符合银行合规要求，请确保邮箱归属人是企业重要成员；重要成员包括：法定代表人、实际控制人、占股超过25%的自然人股东，被授权人等。',
      originalEmail: '原邮箱',
      newEmail: '新邮箱',
      enterNewEmail: '请输入新邮箱',
      emailCode: '邮箱验证码',
      enterEmailCode: '请输入邮箱验证码',
      getCode: '获取验证码',
      prev: '上一步',
      next: '下一步',
      modifyPassword: '修改登录密码',
      enterCurrentPassword: '请输入当前登录密码',
      forgotPassword: '忘记密码',
      newPassword: '新登录密码',
      enterNewPassword: '请输入新登录密码',
      passwordRequirements: '密码须满足以下条件',
      passwordLength: '6-20个字符',
      passwordEnglish: '包含英文字符',
      passwordUpper: '包含大写字母',
      passwordNumber: '包含数字',
      confirmNewPassword: '确认新密码登录',
      enterConfirmPassword: '请输入新登录密码'
    },
    referralLink: {
      title: '专属邀请链接',
      description: '一键复制您的专属链接，邀请客户注册成为麦麦通会员',
      copy: '复制链接',
      copySuccess: '复制成功',
      copyFailed: '复制失败',
      noLink: '暂无邀请链接'
    },
    kycModal: {
      title: '企业认证',
      incomplete: '企业认证未完成',
      desc: '未认证企业无法使用提供的所有服务，简单三步即可完成认证',
      certify: '去认证'
    },
    certificationMaterial: {
      title: '企业认证',
      activateTitle: '激活您的账户',
      countryOfRegistration: '企业所在地',
      countryOfRegistrationEn: 'Country of Registration',
      mainlandChina: '中国大陆',
      hongKong: '中国香港',
      otherCountries: '其他国家/地区',
      selectCountry: '请选择国家/地区',
      requiredDocuments: '所需材料',
      requiredDocumentsMainland: '中国大陆企业认证所需材料',
      requiredDocumentsHongkong: '中国香港企业认证所需材料',
      requiredDocumentsOther: '其他国家/地区认证所需材料',
      corporateInfo: '企业信息',
      enterpriseLegalPerson: '企业法人',
      corporateShareholders: '企业股东',
      enterpriseDirectors: '企业董事',
      directorsShareholders: '企业董事/股东',
      threeInOne: '最新版三证合一',
      businessLicense: '营业执照',
      idPortrait: '身份证人像页',
      idNational: '身份证国徽页',
      legalPersonDesc: '企业法定代表人/个体工商户经营者的',
      shareholderDesc: '个人股东的',
      directorDesc: '企业董事的',
      ci: '注册登记证书(CI)',
      br: '商业登记证(BR)',
      nnc1: '法团成立表(NNC1)',
      nar1: '周年申报表(NAR1)',
      equity: '股权架构',
      passport: '护照',
      registrationCert: '企业注册证书',
      continuedOperation: '持续经营证明文件（存续证明、税务证书、前一年度年审报告等）',
      equityStructure: '股权架构（包含股权架构的文件，公司章程、股东名册等）',
      submitBtn: '资料已准备好，开始认证',
      submitBtnEn: 'Continue to Upload',
      selectCountryWarning: '请选择国家/地区',
      fetchCountryFailed: '获取国家列表失败',
      loadCountryFailed: '加载国家列表失败',
      // Hong Kong specific
      ciEn: 'Certificate of Incorporation (CI)',
      brEn: 'Business Registration Certificate(BR)',
      nnc1En: 'Incorporation Form (NNC1)',
      nar1En: 'Articles of Association / Annual Return (NAR1)',
      equityEn: 'Shareholding Structure',
      directorsInfo: '企业董事',
      directorsInfoEn: 'Directors Information',
      directorsDesc: '企业董事的',
      directorsDescEn: 'For each director, please provide:',
      shareholderDescEn: 'For each individual shareholder, please provide:',
      // Other countries specific
      registrationCertEn: 'Enterprise Registration Certificate, Certificate of Continued Operation (Certificate of Good Standing, Tax Certificate, previous year\'s annual review report, etc.), Equity Structure (documents containing equity structure, Articles of Association, Register of Shareholders, etc.)',
      corporateInfoEn: 'Corporate Information',
      directorsShareholdersEn: 'Directors/shareholders of a company',
      // Mainland specific
      corporateInfoEnMainland: 'Corporate Information',
      enterpriseLegalPersonEn: 'Enterprise legal person',
      corporateShareholdersEn: 'Corporate Shareholders',
      threeInOneEn: 'The latest version of three certificates in one',
      businessLicenseEn: 'Business License',
      legalPersonDescEn: 'Legal representative of the enterprise/individual industrial and commercial proprietor',
      idPortraitEn: 'Identification document (front side)',
      idNationalEn: 'Identification document (back side)',
      shareholderDescEnMainland: 'For each individual shareholder, please provide:'
    },
    enterpriseBasicInfo: {
      certification: '企业认证',
      corporateInfo: '企业信息',
      legalPersonInfo: '法人(董事)股东信息',
      tradeInfo: '贸易信息',
      businessLicense: '营业执照',
      uploadBusinessLicense: '请上传营业执照',
      principalType: '主体类型',
      principalTypeHelp: '公司包括：有限责任公司（自然人独资、自然人投资或控股、非自然人投资或控股的法人独资等）和股份有限公司；个体工商户包括：个体工商户、个体户、非法人商事主体',
      company: '公司',
      individualBusiness: '个体工商户',
      companyNameZh: '企业中文名称',
      enterCompanyNameZh: '请输入企业中文名称',
      companyNameEn: '企业英文名称',
      companyNameEnHint: '（该名称将作为收款账户名称）',
      enterCompanyNameEn: '请输入企业英文名称',
      creditCode: '统一社会信用代码',
      enterCreditCode: '请输入统一社会信用代码',
      validityPeriod: '企业证书有效期',
      certValidityPeriod: '企业证书有效期',
      pleaseSelect: '请选择',
      longTerm: '长期有效',
      selectValidityPeriod: '请选择企业证书有效期',
      selectEndDate: '请选择结束日期',
      pleaseUpload: '请上传',
      registeredAddress: '注册地址',
      selectProvince: '请选择省/州/地区',
      selectCity: '请选择城市/地区',
      enterDetailAddress: '请输入详细地址（具体到区县街道楼门牌号）',
      selectRegisteredAddress: '请选择注册地址',
      physicalAddress: '实际地址',
      sameAsRegistered: '与企业注册地址相同',
      differentFromRegistered: '与企业注册地址不同',
      fillCompleteAddress: '请填写完整的实际地址',
      addressProof: '实际经营地址证明',
      uploadAddressProof: '请上传实际经营地址证明',
      temporaryStorage: '暂存',
      return: '返回',
      next: '下一步',
      savedSuccess: '信息已暂存',
      businessLicenseExample: '营业执照示例',
      addressProofExample: '实际经营地址证明示例',
      fetchProvinceFailed: '获取省份列表失败',
      fetchCityFailed: '获取城市列表失败'
    },
    enterpriseBasicInfoHK: {
      ci: '注册登记证书(CI)',
      ciExample: '注册登记证书示例',
      companyRegNumber: '公司注册号码',
      enterCompanyRegNumber: '请输入公司注册号码',
      hongkong: '中国香港',
      taxBr: '税务证书或商业登记证',
      taxBrExample: '税务证书或商业登记证示例',
      taxNumber: '税务编号或商业登记证号码',
      enterTaxNumber: '请输入税务编号或商业登记证号码',
      taxBrValidity: '税务证书或商业登记证有效期',
      to: '至',
      equity: '企业股权架构',
      equityExample: '企业股权架构示例',
      nar1: '周年申报表(NAR1)',
      nar1Example: '周年申报表示例',
      nnc1: '法团成立表(NNC1)',
      nnc1Example: '法团成立表示例',
      selectCertValidity: '请选择企业证书有效期或勾选长期有效'
    },
    enterpriseBasicInfoOther: {
      registrationCert: '注册证书',
      registrationCertExample: '注册证书示例',
      continuedOperation: '持续经营证明',
      continuedOperationExample: '持续经营证明示例',
      documentNumber: '证明文件编号',
      enterDocumentNumber: '请输入证明文件编号',
      certValidityPeriod: '证件有效日期',
      equityStructure: '股权结构证明',
      equityStructureExample: '股权结构证明示例',
      addressProof: '实际经营地址证明',
      addressProofExample: '实际经营地址证明示例',
      selectRegion: '请选择地区',
      selectCity: '请选择城市/地区',
      enterDetailAddress: '请输入详细地址',
      sameAsRegistered: '与企业注册地址相同',
      differentFromRegistered: '与企业注册地址不同',
      pleaseUpload: '请上传',
      pleaseEnterCompanyNameZh: '请输入企业中文名称',
      pleaseEnterCompanyNameEn: '请输入企业英文名称',
      pleaseEnterCompanyRegNumber: '请输入公司注册号码',
      selectCertValidity: '请选择企业证书有效期或勾选长期有效',
      selectDocValidity: '请选择证件有效日期或勾选长期有效',
      fetchProvinceFailed: '获取省份列表失败',
      fetchCityFailed: '获取城市列表失败'
    },
    enterpriseShareholder: {
      breadcrumb: '企业认证',
      legalPersonInfo: '法人(董事)股东信息',
      tradeInfo: '贸易信息',
      corporateInfo: '企业信息',
      legalPersonTitle: '企业法人信息',
      legalShareholderIdentity: '法人股东身份',
      enterpriseLegalPerson: '企业法人',
      majorityShareholder: '（占股25%）及以上股东',
      shareRatio: '持股比例',
      enterShareRatio: '请输入0-100数字的持股比例',
      enterShareRatioError: '请输入持股比例',
      idType: '证件类型',
      idCard: '身份证',
      passport: '护照',
      selectIdType: '请选择证件类型',
      idRegion: '证件所属地区',
      selectIdRegion: '请选择证件所属地区',
      selectIdRegionError: '请选择证件所属地区',
      idFront: '身份证人像页',
      idBack: '身份证国徽页',
      uploadIdFront: '请上传身份证人像页',
      uploadIdBack: '请上传身份证国徽页',
      legalName: '法人姓名',
      enterLegalName: '请输入法人姓名',
      enterLegalNameError: '请输入法人姓名',
      idNumber: '证件号码',
      enterIdNumber: '请输入证件号码',
      enterIdNumberError: '请输入证件号码',
      birthDate: '出生日期',
      selectBirthDate: '请选择出生日期',
      selectBirthDateError: '请选择出生日期',
      expireDate: '证件到期日期',
      selectExpireDate: '请选择证件到期日期或勾选长期有效',
      selectExpireDateError: '请选择证件到期开始日期',
      selectEndDateOrLongTerm: '请选择证件到期结束日期或勾选长期有效',
      address: '实际居住地址',
      selectCountry: '请选择国家',
      selectCountryError: '请选择国家',
      selectProvince: '请选择省份',
      selectProvinceError: '请选择省份',
      selectCity: '请选择城市',
      selectCityError: '请选择城市',
      enterDetailAddress: '请输入详细地址（具体到区县街道门牌号）',
      enterDetailAddressError: '请输入详细地址',
      passportPhoto: '护照',
      uploadPassport: '请上传护照',
      addressProof: '股东地址证明',
      addressProofTooltip: '带有地址的缴费单、银行对账单或护照',
      uploadAddressProof: '请上传股东地址证明',
      directorTitle: '企业董事信息',
      directorInfo: '董事信息',
      directorShareholderIdentity: '董事股东身份',
      enterpriseDirector: '企业董事',
      directorName: '董事姓名',
      enterDirectorName: '请输入董事姓名',
      addDirector: '添加董事信息',
      delete: '删除',
      shareholderTitle: '企业股东信息',
      shareholderSubtitle: '（占股25%）及以上股东',
      shareholderTooltip: '如无占股25%股东，请提供实际控制人信息',
      addShareholder: '添加股东',
      addShareholderRequired: '请至少添加一位股东',
      shareholderName: '股东姓名',
      enterShareholderName: '请输入股东姓名',
      idPhoto: '证件照片',
      uploadIdPhoto: '请上传证件照片',
      authorizedPersonTitle: '企业授权人信息',
      addAuthorizedPerson: '添加授权人',
      newAuthorization: '新增授权',
      authorizedName: '被授权人姓名',
      enterAuthorizedName: '请输入被授权人姓名',
      authorizationLetter: '企业授权书',
      uploadAuthorizationLetter: '请上传企业授权书',
      downloadTemplate: '点击下载企业授权书模板',
      temporaryStorage: '暂存',
      return: '返回',
      next: '下一步',
      savedSuccess: '信息已暂存',
      selectCountryRegion: '请选择国家/地区',
      selectProvinceState: '请选择省/州/地区',
      selectCityRegion: '请选择城市/地区',
      enterDetailAddress2: '请输入详细地址（具体到区县街道楼号门牌号)',
      selectCountryRegionError: '请选择国家/地区',
      selectProvinceStateError: '请选择省/州/地区',
      selectCityRegionError: '请选择城市/地区',
      enterDetailAddress2Error: '请输入详细地址',
      selectAddressCountry: '请选择国家/地区',
      selectAddressProvince: '请选择省/州/地区',
      selectAddressCity: '请选择城市/地区'
    },
    enterpriseTrade: {
      breadcrumb: '企业认证',
      tradeInfo: '贸易信息',
      corporateInfo: '企业信息',
      legalPersonInfo: '法人(董事)股东信息',
      identityType: '身份类型',
      trader: '我是贸易商',
      licensedInstitution: '我是持牌机构',
      selectIdentityType: '请选择身份类型',
      institutionalQualification: '机构资质信息',
      financialLicense: '金融牌照',
      uploadFinancialLicense: '请上传金融牌照',
      amlQuestionnaire: '反洗钱问卷',
      uploadAmlQuestionnaire: '请上传反洗钱问卷',
      amlPolicy: '反洗钱政策文件',
      uploadAmlPolicy: '请上传反洗钱政策文件',
      tradeInfoTitle: '贸易信息',
      tradeType: '贸易类型',
      selectTradeType: '请选择贸易类型',
      serviceCategory: '服务类别',
      selectServiceCategory: '请选择服务类别',
      ecommercePlatform: '电商平台',
      selectEcommercePlatform: '请选择电商平台',
      mainProduct: '主营产品',
      selectMainProduct: '请选择主营产品',
      businessUrl: '经营网站或APP下载地址',
      enterBusinessUrl: '请输入经营网站或APP下载地址',
      enterBusinessUrlError: '请输入经营网站或APP下载地址',
      estimatedAnnualVolume: '预计年交易金额(USD)',
      enterEstimatedAnnualVolume: '请输入预计年交易金额(USD)',
      enterEstimatedAnnualVolumeError: '请输入预计年交易金额',
      lastYearVolume: '上一年度交易金额(USD)',
      enterLastYearVolume: '请输入上一年度交易金额(USD)',
      enterLastYearVolumeError: '请输入上一年度交易金额',
      mainMarkets: '公司主要展业国家及地区',
      selectMainMarkets: '请选择公司主要展业国家及地区',
      selectMainMarketsError: '请选择公司主要展业国家及地区',
      maxMarketsNote: '最多可选择5个国家/地区',
      maxMarketsWarning: '最多只能选择5个国家/地区',
      warningNote: '注：伊朗、朝鲜、缅甸、苏丹、南苏丹、叙利亚、古巴、伊拉克、阿富汗、中非共和国、刚果民主共和国、厄立特里亚、几内亚比绍、黎巴嫩、利比亚、马里、索马里、也门，以上国家不能进行作业。',
      uploadOtherMaterials: '其他材料上传',
      temporaryStorage: '暂存',
      return: '返回',
      submit: '提交认证',
      submitting: '正在提交，请稍候...',
      submitSuccess: '提交成功',
      submitSuccessMessage: '企业认证申请已提交，我们将在1-3个工作日内完成审核',
      confirm: '确定',
      savedSuccess: '信息已暂存',
      amountFormatError: '预计年交易金额格式不正确，最多两位小数',
      lastYearAmountFormatError: '上一年度交易金额格式不正确，最多两位小数',
      selectMainMarketsWarning: '请选择公司主要展业国家及地区',
      submitFailed: '提交失败',
      submitFailedMessage: '企业认证提交失败，请稍后重试'
    },
    fileUpload: {
      viewExample: '查看示例',
      uploadText: '点击上传，将上传的文件拖至此处',
      fileTypeHint: '支持JPG、PNG、JPEG、PDF格式，不超过20MB',
      clickToPreview: '点击放大预览',
      imagePreview: '图片预览',
      fileSizeExceed: '文件大小不能超过20MB',
      onlySupportFormats: '只支持JPG、PNG、JPEG、PDF格式',
      uploadSuccess: '上传成功',
      uploadFailed: '上传失败',
      deleteSuccess: '已删除文件'
    },
    overseasRemittanceAccountDetail: {
      breadcrumb: '境外汇款账户',
      detailTitle: '账户详情',
      accountBelong: '账户归属',
      accountType: '账户类型',
      companyAccount: '企业账户',
      personalAccount: '个人账户',
      legalPerson: '法人/股东',
      employee: '员工',
      accountInfo: '账户信息',
      bankRegion: '开户行所在地区',
      accountCurrency: '账户币种',
      bankAccountName: '银行账户名称',
      bankAccountNumber: '银行账号',
      bankName: '银行名称',
      swiftCode: 'SWIFT Code/BIC',
      bankAddress: '银行地址',
      back: '返回',
      supplier: '账户供应商',
      enterprise: '账户本企业'
    },
    tradeOrderDetail: {
      breadcrumb: '贸易单',
      detailTitle: '贸易单详情',
      merchantOrderNo: '商户订单号',
      tradeNo: '贸易单号',
      paymentCurrency: '收款币种',
      tradeType: '贸易类型',
      contractNo: '合同编号',
      tradeCountry: '贸易国家/地区',
      tradeAmount: '合同金额',
      associatedAmount: '已关联金额',
      associationRatio: '关联比例',
      counterparty: '付款方英文名',
      status: '状态',
      createTime: '创建时间',
      updateTime: '更新时间',
      rejectReason: '驳回原因',
      tradeMaterials: '贸易材料',
      download: '下载',
      backToList: '返回列表',
      goodsTrade: '货物贸易',
      serviceTrade: '服务贸易',
      invoiceContract: '合同/发票文件',
      contractFiles: '合同文件',
      piCiFiles: 'PI/CI文件',
      proofMaterials: '证明材料',
      otherFiles: '其他文件',
      missingId: '缺少订单ID',
      fetchFailed: '获取详情失败',
      statusInCollection: '收款中',
      statusRejected: '已驳回',
      statusApproved: '进行中',
      statusUnderReview: '审核中',
      statusCompleted: '收款完成',
      statusClosed: '已关闭',
      relatedReceipts: '已关联贸易收款单',
      receiptNo: '贸易收款单号',
      receiptDate: '到账日期',
      entryDate: '入账日期',
      receivingAccount: '收款账户',
      statusPending: '待处理',
      statusSuccess: '成功',
      statusReviewing: '审核中',
      view: '查看'
    },
    tradeReceiptDetail: {
      breadcrumb: '贸易收款单',
      detailTitle: '贸易收款单详情',
      orderNo: '贸易收款单号',
      tradeNo: '交易号',
      currency: '币种',
      orderAmount: '付款金额',
      accountNo: '收款账户',
      paymentAccountNo: '付款方账号',
      paymentAccountName: '付款方账户名称',
      paymentBankName: '付款方银行名称',
      reference: '参考号',
      status: '状态',
      receiptDate: '到账日期',
      entryDate: '入账日期',
      rejectReason: '驳回原因',
      remark: '备注',
      createTime: '创建时间',
      updateTime: '更新时间',
      backToList: '返回列表',
      missingId: '缺少收款单ID',
      fetchFailed: '获取详情失败',
      statusPending: '待关联',
      statusReviewing: '处理中',
      statusRejected: '已驳回',
      statusSuccess: '入账成功',
      statusFail: '失败'
    },
    legalAccount: {
      title: '法币账户',
      totalAssetLabel: '总资产估值',
      deposit: '入金',
      withdraw: '提现',
      addBankAccount: '添加银行账户',
      depositProcessing: '转入处理中资产',
      withdrawProcessing: '提现中的资产',
      availableBalance: '可用余额',
      accountList: '账户列表',
      transactionDetails: '交易明细',
      depositRecords: '入金记录',
      withdrawRecords: '提现记录',
      currency: '币种',
      balance: '余额',
      value: '价值',
      assetProportion: '资产占比',
      transactionId: '交易编号',
      transactionType: '交易类型',
      transactionTime: '交易时间',
      transactionBalance: '交易金额',
      transactionFee: '手续费',
      transactionStatus: '交易状态',
      remark: '备注',
      operation: '操作',
      detail: '详情',
      search: '搜索',
      enterTransactionId: '请输入交易编号',
      selectTransactionType: '请选择交易类型',
      startDate: '开始日期',
      endDate: '结束日期',
      typeTransferOut: '汇出',
      typeTransferIn: '汇入',
      status: '状态',
      selectStatus: '请选择状态',
      statusSuccess: '成功',
      statusFailed: '失败',
      statusCompleted: '已完成',
      statusPending: '待审核',
      statusRejected: '已拒绝',
      statusApproved: '已批准',
      statusCancelled: '已取消',
      depositAmount: '入金金额',
      fee: '手续费',
      feeRate: '费率',
      actualAmount: '实际金额',
      depositCurrency: '入金币种',
      depositStatus: '入金状态',
      depositTime: '入金时间',
      walletAddress: '钱包地址',
      withdrawAmount: '提现金额',
      combinedFee: '手续费',
      withdrawCurrency: '提现币种',
      withdrawTime: '提现时间',
      withdrawBankNum: '提现银行帐号',
      withdrawBankName: '提现银行名称',
      feeMethod: '手续费承担方式',
      feeMethodPayee: '收款方承担',
      feeMethodPayer: '入款方承担',
      noRemark: '无备注',
      copySuccess: '复制成功',
      copyFailed: '复制失败',
      transactionDetail: '交易详情',
      basicInfo: '基本資訊',
      amountInfo: '金額資訊'
    },
    legalWithdraw: {
      back: '返回',
      title: '提现',
      receiveCurrency: '收款币种',
      selectCurrency: '请选择收款币种',
      withdrawBank: '转出银行',
      selectBank: '请选择转出银行',
      feeMethod: '手续费承担方式',
      selectFeeMethod: '请选择手续费承担方式',
      feeEach: '各自承担',
      feeSender: '汇款方承担',
      feeReceiver: '收款方承担',
      withdrawAmount: '转出金额',
      enterAmount: '请输入转出金额',
      allOut: '全部转出',
      combinedFee: '手续费',
      actualAmount: '实际到账金额',
      confirm: '确认',
      confirmWithdraw: '确认提现',
      confirmTitle: '提示',
      confirmMessage: '确认提现吗？',
      cancel: '取消',
      submitSuccess: '提现提交成功',
      submitFailed: '提现提交失败',
      availableBalance: '可用余额',
      amountExceedsBalance: '转出金额不能超过可用余额'
    },
    bankAccount: {
      title: '银行账户',
      refresh: '刷新',
      addBank: '新增银行卡',
      editBank: '编辑银行卡',
      bankName: '银行名称',
      bankNumber: '银行帐号',
      bankIfsc: 'SWIFT代码',
      legalName: '法定全名',
      countryName: '所属国家',
      bankCity: '银行所在城市',
      bankAddress: '银行地址',
      receiveCurrency: '收款币种',
      currency: '币种',
      selectCurrency: '请选择币种',
      enterCurrency: '请输入币种',
      createTime: '建立时间',
      operation: '操作',
      edit: '编辑',
      detail: '详情',
      bankDetail: '银行卡详情',
      delete: '删除',
      deleteConfirm: '确定要删除该银行账户吗？',
      warning: '警告',
      confirm: '确定',
      cancel: '取消',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      cancelDelete: '已取消删除',
      enterBankName: '请输入银行名称',
      enterBankNumber: '请输入银行帐号',
      enterSwiftCode: '请输入 SWIFT 代码',
      enterLegalName: '请输入法定全名',
      selectCountry: '请选择',
      enterBankCity: '请输入银行所在城市',
      enterBankAddress: '请输入银行地址',
      addSuccess: '新增成功',
      editSuccess: '编辑成功',
      submitFailed: '提交失败'
    }
  },
  en: {
    common: {
      fetchFailed: 'Failed to fetch data',
      submitFailed: 'Submit failed',
      back: 'Back',
      loading: 'Loading...'
    },
    login: {
      title: 'Login to your Paymmt Account',
      email: 'Email',
      password: 'Please enter password (6-20 digits+letters)',
      captcha: 'Please enter captcha',
      refreshCaptcha: 'Click to refresh captcha',
      remember: 'Remember Me',
      forgot: 'Forgot Password?',
      submit: 'Login',
      register: 'Register',
      noAccount: 'Don\'t have an account?',
      acquiringPlatform: 'Acquiring Platform',
      enterEmail: 'Please enter email address',
      emailInvalid: 'Invalid email format, please enter a valid email address',
      enterPassword: 'Please enter password',
      enterCaptcha: 'Please enter captcha',
      loginSuccess: 'Login successful',
      loginFailed: 'Login failed',
      loggingIn: 'Logging in...'
    },
    register: {
      title: 'Create Your Paymmt Account',
      hasAccount: 'Already have an account?',
      login: 'Login',
      companyLocation: 'Where is your company headquartered?',
      email: 'Email',
      verifyCode: 'Verification Code',
      sendCode: 'Send Code',
      companyName: 'Company Full Name',
      password: 'Please enter password (6-20 digits+letters)',
      confirmPassword: 'Please enter password (6-20 digits+letters)',
      agree: 'I have read and agree to',
      userAgreement: 'User Agreement',
      and: 'and',
      privacyPolicy: 'Privacy Policy',
      submit: 'Register Now',
      selectLocation: 'Please select company location',
      enterEmail: 'Please enter email',
      emailFormat: 'Please enter a valid email address',
      enterVerifyCode: 'Please enter verification code',
      enterCompanyName: 'Please enter company full name',
      enterPassword: 'Please enter password',
      passwordLength: 'Password must be at least 6 characters',
      agreeTerms: 'Please agree to User Agreement and Privacy Policy',
      passwordRequirements: 'Password must meet the following conditions',
      passwordLengthTip: '6-20 characters',
      passwordEnglishTip: 'Contains English characters',
      passwordNumberTip: 'Contains numbers'
    },
    forgotPassword: {
      title: 'Reset Password',
      subtitle: 'Please enter your email address, we will send a verification code to your email',
      email: 'Email',
      verifyCode: 'Verification Code',
      sendCode: 'Send Code',
      newPassword: 'Please enter password (6-20 digits+letters)',
      confirmPassword: 'Please enter password (6-20 digits+letters)',
      submit: 'Reset Password',
      backToLogin: 'Back to Login',
      emailRequired: 'Please enter email',
      emailInvalid: 'Please enter a valid email address',
      verifyCodeRequired: 'Please enter verification code',
      passwordRequired: 'Please enter new password',
      passwordMin: 'Password must be at least 6 characters',
      confirmPasswordRequired: 'Please confirm password',
      passwordMismatch: 'Passwords do not match',
      codeSent: 'Verification code sent',
      resetSuccess: 'Password reset successfully',
      passwordRequirements: 'Password must meet the following conditions',
      passwordLengthTip: '6-20 characters',
      passwordEnglishTip: 'Contains English characters',
      passwordNumberTip: 'Contains numbers'
    },
    sidebar: {
      dashboard: 'Home',
      collection: 'Pay-ins',
      tradeOrder: 'Trade Order',
      tradeCollection: 'Trade receipt',
      exchange: 'Conversions',
      exchangeOrder: 'Exchange Order',
      foreignExchange: 'Foreign Exchange',
      foreignExchangeList: 'Foreign Exchange List',
      settlement: 'Settlement',
      settlementOrder: 'Settlement Order',
      settlementWithdrawOrder: 'Settlement Withdraw Order',
      settlementQuota: 'Settlement Quota',
      loan: 'Loan',
      transferRemittance: 'Transfer Remittance',
      fundManagement: 'Fund Management',
      myWallet: 'My Wallet',
      accountManagement: 'Account Management',
      foreignTradeAccount: 'Foreign Trade Account',
      rmbSettlementAccount: 'RMB Settlement Account',
      overseasRemittanceAccount: 'Overseas Remittance Account',
      my: 'My',
      announcementList: 'Announcement List',
      enterpriseCertification: 'Enterprise Certification',
      accountSecurity: 'Account Security',
      roleManagement: 'Role Management',
      operatorManagement: 'Operator Management',
      keyManagement: 'Key Management'
    },
    header: {
      company: 'Hong Kong Techwin Co., Limited'
    },
    dashboard: {
      title: 'Asset Overview',
      pending: 'Pending Tasks',
      exchangeRate: 'Reference Exchange Rate',
      bankHoliday: 'Bank Holiday Calendar',
      attention: 'Attention Currencies',
      totalAssets: 'Total assets',
      collection: 'Collection',
      exchange: 'Exchange',
      selectedDate: 'Selected Date',
      noHoliday: 'No holiday information for this date',
      selectCurrency: 'Select source currency',
      enterAmount: 'Please enter amount'
    },
    language: {
      chinese: '中文',
      english: 'English'
    },
    userInfo: {
      merchantNo: 'Merchant No.',
      merchantId: 'Merchant ID',
      merchantName: 'Merchant Name',
      operatorName: 'Operator Name',
      loginEmail: 'Login Email',
      logout: 'Logout'
    },
    unavailable: {
      description: 'This feature is not yet available, please stay tuned!',
      back: 'Back to Home'
    },
    enterprise: {
      title: 'Enterprise Certification',
      activateAccount: 'ACTIVATE YOUR ACCOUNT',
      beforeJoin: 'After the merchant has successfully joined the network, You can carry out the business services',
      afterJoin: 'Merchant joined successfully',
      addBasicInfo: 'Add Business Information',
      addBusinessInfo: 'Add Business Information'
    },
    tradeOrder: {
      title: 'Bill of trade',
      all: 'All',
      inCollection: 'In collection',
      underReview: 'Under Review',
      completed: 'Collection Completed',
      rejected: 'Rejected',
      closed: 'Closed down',
      approved: 'Processing',
      create: 'Create a trade order',
      createDate: 'Date creation',
      collectionCurrency: 'Collection Currency',
      buyerContract: 'Name of buyer/Contract No',
      tradeType: 'Trade type',
      startTime: 'Start Time',
      to: 'To',
      endTime: 'End Time',
      selectCollectionCurrency: 'Please select Collection Currency',
      enterBuyerContract: 'Please enterName of buyer/Contract No',
      selectTradeType: 'Please select Trade type',
      search: 'search',
      download: 'Download',
      contractNo: 'Contract Number',
      buyerName: 'English name of buyer',
      tradeArea: 'Area of trade',
      contractAmount: 'Contract amount',
      associatedAmount: 'Associated amount',
      status: 'State',
      associationRatio: 'Proportion of association',
      operation: 'Operation',
      detail: 'Detail',
      edit: 'Edit',
      noData: 'No Data',
      goodsTrade: 'Goods Trade',
      serviceTrade: 'Service Trade'
    },
    createTradeOrder: {
      breadcrumb: 'Bill of trade',
      createTitle: 'Create a trade order',
      editTitle: 'Edit a trade order',
      collectionInfo: 'Collection Information',
      paymentCurrency: 'Collection Currency',
      selectPaymentCurrency: 'Please select collection currency',
      tradeType: 'Trade Type',
      goodsTrade: 'Goods Trade',
      serviceTrade: 'Service Trade',
      tradeMaterials: 'Goods Trade',
      materialNote: 'Note: CONTRACT and PI/CI type files cannot be empty at the same time',
      contractFile: 'Contract',
      contractUploadTip: 'Please upload the contract. JPG, JPEG, PNG and PDF formats are supported. You can upload up to 5 files, and each file must be less than 20 MB.',
      piCiFile: 'PI/CI',
      piCiUploadTip: 'Please upload CI or PI, at least one of them. Supported formats: JPG, JPEG, PNG, PDF. A maximum of 5 files can be uploaded, and each file must be less than 20MB.',
      proofMaterials: 'Supporting documents',
      proofUploadTip: 'For general trade, please upload delivery notes; for e-commerce and other scenarios, please upload order details and other relevant documents. Supported formats: JPG, JPEG, PNG, PDF. A maximum of 5 files can be uploaded, and each file must be less than 20MB.',
      contractNo: 'Contract Number',
      enterContractNo: 'Please enterContract Number',
      contractAmount: 'Amount contract',
      enterContractAmount: 'Please enterAmount contract',
      tradeCountry: 'Trading countries/regions',
      selectTradeCountry: 'Please select trading country/region',
      buyerName: 'English name of buyer',
      enterBuyerName: 'Please enterEnglish name of buyer',
      sanctionNote: 'Description of sanctioned countries',
      sanctionTooltip: 'Select the payment country. For example, if you pay euros from Italy, select "Italy" as the "payment country"',
      sanctionCountries: 'Note: Afghanistan, Albania, Belarus, Bosnia and Herzegovina, Central African Republic, Cuba, Democratic Republic of the Congo - DRC, Ethiopia, Haiti, Iran, Iraq, Lebanon, Libya, Myanmar, Nicaragua, North Korea, Russian Federation, Somalia, South Sudan, Sudan, Syria, Ukraine, Venezuela, Yemen, ISIS (Daesh) and Al-Qaeda, Taliban, Montenegro, Serbia, Gaza Strip, Pakistan - operations cannot be conducted in the above countries',
      saveDraft: 'Temporarily save as a draft',
      submit: 'Submit',
      submitting: 'Submitting...',
      draftSuccess: 'Draft saved successfully',
      submitConfirm: 'Are you sure you want to submit this trade order?',
      confirmSubmit: 'Confirm submission',
      confirm: 'Confirm',
      cancel: 'Cancel',
      submitSuccess: 'Submitted successfully',
      submitFail: 'Submission failed',
      uploadSuccess: 'Upload successful',
      uploadFail: 'File upload failed',
      fileSizeError: 'File size cannot exceed 20MB',
      proofContractEmpty: 'PROOF_MATERIALS and CONTRACT cannot be empty at the same time',
      uploadAtLeastOne: 'Please upload at least one proof file',
      selectPaymentCurrencyRule: 'Please select Collection Currency',
      selectTradeTypeRule: 'Please select Trade type',
      enterContractNoRule: 'Please enterContract Number',
      enterContractAmountRule: 'Please enterAmount contract',
      amountFormatError: 'Please enter the correct amount format, up to two decimal places',
      selectTradeCountryRule: 'Please select Trading countries/regions',
      enterBuyerNameRule: 'Please enterEnglish name of buyer',
      selectTradeType: 'Please select Trade type',
      selectTradeTypePlaceholder: 'Please select Trade type',
      amountSuffix: 'Please enterAmount contract',
      fetchFailed: 'Failed to fetch data'
    },
    tradeReceipt: {
      title: 'Trade receipts',
      all: 'All',
      pending: 'To be associated',
      rejected: 'Rejected',
      processing: 'Processing',
      success: 'Successful entry',
      fail: 'Fail',
      receiptDate: 'Date of receipt',
      entryDate: 'Date of entry',
      payerKeyword: 'Payer/receiving account/trade receipt number',
      payerKeywordPlaceholder: 'Payer/receiving account/trade receipt',
      startTime: 'Start Time',
      to: 'To',
      endTime: 'End Time',
      search: 'search',
      batchRelate: 'Batch related',
      download: 'Download',
      receiptNo: 'Trade receipt number',
      receiptEntryDate: 'Date of receipt/Date of entry',
      payer: 'Payer',
      paymentAmount: 'Payment amount',
      fee: 'Service Charge',
      accountNo: 'Collection account',
      tradeNo: 'Trade Order No',
      operation: 'Operation',
      status: 'State',
      noData: 'No Data',
      detail: 'Detail',
      relate: 'Relate',
      cancel: 'Cancel',
      confirmRelate: 'Confirm association',
      selectTradeNo: 'Please select trade order number',
      selectRowsWarning: 'Please select trade receipts that are pending, failed, or rejected',
      allLinkedWarning: 'Please select corresponding trade order number for all trade receipts',
      relateSuccess: 'Batch association successful',
      relateFail: 'Batch association failed',
      downloadDev: 'Download feature under development'
    },
    exchangeOrder: {
      title: 'To exchange',
      sellAmount: 'Sales Amount',
      enterSellAmount: 'Please enter Sales Amount',
      selectSellCurrency: 'Please select Sell',
      availableBalance: 'Available Balance',
      fullExchange: 'Full Exchange',
      exchangeTime: 'Exchange operation time',
      startTime: 'Start Time',
      endTime: 'End Time',
      to: 'to',
      beijingTime: 'Beijing Time',
      buyAmount: 'Purchase Amount',
      enterBuyAmount: 'Please enter Purchase Amount',
      selectBuyCurrency: 'Please select Buy',
      exchangeRate: 'Exchange Rate',
      submitExchange: 'Submit exchange',
      recentOrders: 'Exchange orders recently',
      orderNo: 'Exchange Order No',
      createTime: 'Creation Time',
      sellAmountLabel: 'Sales Amount',
      buyAmountLabel: 'Purchase Amount',
      rate: 'Exchange Rate',
      status: 'State',
      completeTime: 'Completion Time',
      moreOrders: 'More Orders',
      enterSellAmountWarning: 'Please enter Sales Amount',
      selectSellCurrencyWarning: 'Please select Sell',
      selectBuyCurrencyWarning: 'Please select Buy',
      sameCurrencyWarning: 'Sell currency and buy currency cannot be the same',
      exceedBalanceWarning: 'Sales amount cannot exceed available balance',
      cannotExchangeWarning: 'Cannot exchange at the moment, please try again later',
      confirmExchange: 'Confirm exchange',
      confirmExchangeText: 'Confirm to exchange',
      exchangeTo: 'to',
      success: 'Submitted successfully',
      fail: 'Submission failed',
      processing: 'Processing',
      successStatus: 'Success',
      failed: 'Failed',
      cancelled: 'Cancelled'
    },
    transferRemittance: {
      title: 'Transfer remittance',
      orderRecord: 'Record order',
      singleRemittance: 'single remittance',
      multipleRemittance: 'Multiple remittances',
      platformTransfer: 'Transfer money to other merchants on the platform',
      selectPayee: 'Choose the recipient',
      fillRemittanceInfo: 'Fill in remittance information',
      confirmRemittance: 'Confirmation of remittance',
      whoToRemit: 'Who would you like to remit the money to?',
      searchAccount: 'Search for the account name or bank account number you want to remit',
      addOverseasAccount: 'Add overseas remittance account',
      next: 'Next',
      prev: 'Previous',
      remitAmount: 'Remittance Amount',
      enterRemitAmount: 'Please enter Remittance Amount',
      selectCurrency: 'Please select currency',
      remitRemark: 'Remittance Remark',
      enterRemark: 'Please enter remittance remark (optional)',
      fee: 'Fee',
      noRemark: 'None',
      confirmRemitBtn: 'Confirm Remittance',
      selectPayeeWarning: 'Please select a payee',
      enterRemitAmountWarning: 'Please enter Remittance Amount',
      exceedBalanceWarning: 'Remittance amount cannot exceed available balance',
      remitSuccess: 'Remittance submitted successfully',
      uploadTemplate: 'Please upload remittance template',
      uploadOrDrag: 'Click or drag to upload remittance template',
      excelFormat: 'Supports Excel format files',
      totalAmount: 'Total',
      totalUnit: 'entries, cumulative amount',
      noData: 'No Data',
      payeeName: 'Payee Account Name',
      accountNumber: 'Account Number',
      bankName: 'Receiving Bank Name',
      amount: 'Amount',
      downloadTemplate: 'Download batch remittance template',
      uploadDev: 'Upload feature under development',
      downloadTemplateDev: 'Download template feature under development',
      selectMerchant: 'Which merchant would you like to transfer to?',
      searchMerchantCode: 'Search for the merchant code of the other merchant you want to transfer to',
      transferAmount: 'Transfer Amount',
      enterTransferAmount: 'Please enter Transfer Amount',
      transferRemark: 'Transfer Remark',
      enterTransferRemark: 'Please enter transfer remark (optional)',
      confirmTransfer: 'Transfer Confirmation',
      merchantCode: 'Receiving Merchant Code',
      confirmTransferBtn: 'Confirm Transfer',
      enterMerchantCodeWarning: 'Please enter merchant code',
      enterTransferAmountWarning: 'Please enter Transfer Amount',
      transferSuccess: 'Transfer submitted successfully',
      all: 'All',
      processing: 'In Review',
      reviewRejected: 'Review Rejected',
      success: 'Success',
      failed: 'Fail',
      completed: 'Completed',
      cancelled: 'Cancelled',
      deductCurrency: 'Currency deduction',
      selectDeductCurrency: 'Please select Currency deduction',
      receiveCurrency: 'Currency of receipt',
      selectReceiveCurrency: 'Please select Currency of receipt',
      orderNo: 'orderNo',
      enterOrderNo: 'Please enter orderNo',
      orderTime: 'Order time',
      startTime: 'Start Time',
      endTime: 'End Time',
      payoutType: 'Type disbursement',
      selectPayoutType: 'Please select Type disbursement',
      type1: 'Type 1',
      type2: 'Type 2',
      search: 'search',
      download: 'Download',
      tradeTime: 'Trading Time',
      deductAmount: 'Deduction amount',
      receiveAmount: 'Amount Received',
      exchangeRate: 'Exchange Rate',
      fee: 'Service Charge',
      orderStatus: 'Order Status',
      payee: 'The payee',
      remittanceType: 'Remittance type',
      operation: 'Operation',
      detail: 'Detail',
      fetchFail: 'Failed to get order list',
      exportDev: 'Export feature under development',
      copySuccess: 'Copy successful',
      detailDev: 'View detail feature under development'
    },
    transferRemittanceOrderDetail: {
      breadcrumb: 'Transfer Remittance',
      detailTitle: 'Remittance Order Detail',
      merchantOrderNo: 'Order No',
      orderNo: 'Order No',
      sellCurrency: 'Sell Currency',
      sellAmount: 'Sell Amount',
      buyCurrency: 'Buy Currency',
      buyAmount: 'Buy Amount',
      merchantBidPrice: 'Merchant Bid Price',
      merchantFee: 'Fee',
      payeeType: 'Payee Type',
      orderStatus: 'Order Status',
      createTime: 'Create Time',
      completeTime: 'Complete Time',
      name: 'Payee Name',
      accountNumber: 'Account Number',
      country: 'Country',
      subjectType: 'Subject Type',
      reference: 'Reference',
      feeBearer: 'Fee Bearer',
      failReason: 'Fail Reason',
      back: 'Back',
      missingId: 'Missing order ID',
      fetchFailed: 'Failed to fetch detail',
      payeeTypeOther: 'Other Services',
      payeeTypePlatform: 'Platform Merchant',
      payeeTypeOverseas: 'Overseas Account',
      subjectPrivate: 'To Private',
      subjectCompany: 'To Company',
      feeBearerOur: 'OUR',
      feeBearerSha: 'SHA',
      feeBearerBen: 'BEN'
    },
    remittanceApply: {
      breadcrumb: 'Transfer remittance',
      fillRemittanceInfo: 'Fill in remittance information',
      basicInfo: 'Basic Information',
      sellCurrency: 'Sell Currency',
      selectSellCurrency: 'Please select Sell Currency',
      buyCurrency: 'Buy Currency',
      selectBuyCurrency: 'Please select Buy Currency',
      sellAmount: 'Sales Amount',
      buyAmount: 'Purchase Amount',
      amountPlaceholder: 'Please enter either Sales Amount or Purchase Amount',
      amountValidator: 'Please enter either Sales Amount or Purchase Amount',
      remittanceType: 'Remittance Type',
      selectRemittanceType: 'Please select Remittance Type',
      logistics: 'Logistics',
      advertising: 'Advertising',
      supplier: 'Supplier',
      withdraw: 'Withdraw',
      travel: 'Travel',
      infoService: 'Information Service Fee',
      otherExpense: 'Other Expenses',
      salary: 'Salary or Commission Payment',
      feeServices: 'Fee',
      refund: 'Refund',
      feeBearer: 'Fee Bearer',
      selectFeeBearer: 'Please select Fee Bearer',
      sha: 'SHA (Shared)',
      our: 'OUR (Payer)',
      feeBearerTip: 'Only effective when Buy Currency is USD, CNH, EUR, GBP',
      feeBearerDesc: 'SHA: SWIFT telegraph transfer fees shared by you and the payee; OUR: You bear all fees, payee receives full amount',
      quoteId: 'Quote Reference ID',
      quoteIdPlaceholder: 'Required when Sell Currency differs from Buy Currency',
      reference: 'Remittance Remark',
      enterReference: 'Please enter remittance remark',
      sameName: 'Same Name Transfer',
      yes: 'Yes',
      no: 'No',
      fastArrival: 'Fast Arrival',
      fastArrivalTip: 'Fast arrival operating hours: Non-holidays 00:00-16:00 (Beijing Time)',
      payeeInfo: 'Payee Information',
      payeeAccountType: 'Payee Account Type',
      selectPayeeAccountType: 'Please select Payee Account Type',
      b2b: 'B2B Public',
      b2c: 'B2C Private',
      payeeAccountNumber: 'Payee Account Number',
      enterPayeeAccountNumber: 'Please enter Payee Account Number',
      payeeAccountName: 'Payee Account Name',
      enterPayeeAccountName: 'Please enter Payee Account Name',
      payeeCountry: 'Payee Country',
      selectPayeeCountry: 'Please select Payee Country',
      payeeAddress: 'Payee Address',
      enterPayeeAddress: 'Please enter Payee Address',
      firstName: 'First Name',
      firstNamePlaceholder: 'Required for B2C Private',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Required for B2C Private',
      payeePhone: 'Payee Phone Number',
      phonePlaceholder: 'Required when remitting to Indonesia',
      payeeIdCard: 'Payee ID Number',
      enterPayeeIdCard: 'Please enter Payee ID Number',
      bankCode: 'Bank Code',
      bankCodePlaceholder: 'Required when Buy Currency is not USD',
      bankName: 'Bank Name',
      bankNamePlaceholder: 'Required when Buy Currency is USD',
      bankCountry: 'Bank Country',
      selectBankCountry: 'Please select Bank Country',
      bankAddress: 'Bank Address',
      enterBankAddress: 'Please enter Bank Address',
      swiftCode: 'Swift Code',
      enterSwiftCode: 'Please enter Swift Code',
      iban: 'IBAN',
      ibanPlaceholder: 'Required for EU bank accounts',
      sortCode: 'Sort Code',
      sortCodePlaceholder: 'Required for UK bank accounts',
      bsbNumber: 'BSB Number',
      bsbPlaceholder: 'Required for Australian bank accounts',
      postCode: 'Post Code',
      postCodePlaceholder: 'Required for US bank accounts',
      routingNumber: 'Routing Number',
      enterRoutingNumber: 'Please enter Routing Number',
      lineNumber: 'Line Number',
      enterLineNumber: 'Please enter Line Number',
      voucherFiles: 'Voucher Files',
      voucherFilesHint: 'For B2C: Invoice or Contract, choose one; For B2B: both required',
      invoiceFiles: 'Invoice Files',
      contractFiles: 'Contract Files',
      uploadTip: 'JPG, JPEG, PNG, PDF formats supported. Maximum 5 files, each less than 20MB',
      uploading: 'Uploading',
      fileValidator: 'Please upload at least one of Invoice or Contract files',
      prevStep: 'Previous',
      nextStep: 'Next: Confirm Remittance',
      uploadSuccess: 'Upload successful',
      uploadFailed: 'File upload failed',
      fetchCurrencyFailed: 'Failed to fetch currency list',
      fetchCountryFailed: 'Failed to fetch country list',
      fetchAccountFailed: 'Failed to fetch payee information',
      sellCurrencyRequired: 'Please select Sell Currency',
      buyCurrencyRequired: 'Please select Buy Currency',
      remittanceTypeRequired: 'Please select Remittance Type',
      feeBearerRequired: 'Please select Fee Bearer',
      payeeAccountTypeRequired: 'Please select Payee Account Type',
      payeeAccountNumberRequired: 'Please enter Payee Account Number',
      payeeAccountNameRequired: 'Please enter Payee Account Name',
      payeeCountryRequired: 'Please select Payee Country',
      payeeAddressRequired: 'Please enter Payee Address',
      bankCountryRequired: 'Please select Bank Country'
    },
    remittanceConfirm: {
      title: 'Remittance Confirmation',
      basicInfo: 'Basic Information',
      sellCurrency: 'Sell Currency',
      buyCurrency: 'Buy Currency',
      sellAmount: 'Sales Amount',
      buyAmount: 'Purchase Amount',
      remittanceType: 'Remittance Type',
      feeBearer: 'Fee Bearer',
      quoteId: 'Quote Reference ID',
      reference: 'Remittance Remark',
      sameName: 'Same Name Transfer',
      fastArrival: 'Fast Arrival',
      yes: 'Yes',
      no: 'No',
      payeeInfo: 'Payee Information',
      payeeAccountType: 'Payee Account Type',
      payeeAccountNumber: 'Payee Account Number',
      payeeAccountName: 'Payee Account Name',
      payeeCountry: 'Payee Country',
      payeeAddress: 'Payee Address',
      firstName: 'First Name',
      lastName: 'Last Name',
      payeePhone: 'Payee Phone Number',
      payeeIdCard: 'Payee ID Number',
      bankCode: 'Bank Code',
      bankName: 'Bank Name',
      bankCountry: 'Bank Country',
      bankAddress: 'Bank Address',
      swiftCode: 'Swift Code',
      iban: 'IBAN',
      sortCode: 'Sort Code',
      bsbNumber: 'BSB Number',
      postCode: 'Post Code',
      routingNumber: 'Routing Number',
      lineNumber: 'Line Number',
      voucherFiles: 'Voucher Files',
      invoiceFiles: 'Invoice Files',
      contractFiles: 'Contract Files',
      download: 'Download',
      prevStep: 'Previous',
      confirmRemit: 'Confirm Remittance',
      noDataWarning: 'No remittance information found, please fill in again',
      submitSuccess: 'Remittance application submitted',
      submitFailed: 'Remittance submission failed',
      b2b: 'B2B Public',
      b2c: 'B2C Private',
      logistics: 'Logistics',
      advertising: 'Advertising',
      supplier: 'Supplier',
      withdraw: 'Withdraw',
      travel: 'Travel',
      infoService: 'Information Service Fee',
      otherExpense: 'Other Expenses',
      salary: 'Salary or Commission Payment',
      feeServices: 'Fee',
      refund: 'Refund'
    },
    myWallet: {
      title: 'My money',
      totalBalanceLabel: 'Current total balance valuation of each currency',
      currency: 'Currency',
      availableBalance: 'Available Balance',
      operation: 'Operation',
      exchange: 'Exchange',
      fundFlow: 'Capital flow',
      noData: 'No Data',
      fetchFailed: 'Failed to fetch wallet data'
    },
    fundFlow: {
      title: 'Capital flow',
      currency: 'Currency',
      select: 'Select',
      capitalDirection: 'Capital direction',
      increase: 'Income',
      decrease: 'Expense',
      businessType: 'Business Type',
      receipt: 'Receipt',
      remittance: 'Remittance',
      exchange: 'Exchange',
      transfer: 'Transfer',
      withdraw: 'Withdraw',
      tradeTime: 'Trading Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      to: 'To',
      search: 'search',
      download: 'Download',
      transactionAmount: 'Transaction Amount',
      postBalance: 'Post transaction balance',
      operation: 'Operation',
      detail: 'Detail',
      downloadDev: 'Download feature under development',
      detailDev: 'View detail feature under development'
    },
    digitalAccount: {
      title: 'Digital Currency/Digital Asset',
      totalAssetLabel: 'Total Converted Cryptographic Assets',
      deposit: 'Recharge',
      withdraw: 'Withdraw',
      exchange: 'Exchange',
      walletManage: 'Wallet Management',
      accountList: 'Account List',
      transactionDetails: 'Transaction Details',
      depositRecords: 'Deposit Records',
      withdrawRecords: 'Withdrawal Records',
      currency: 'Currency',
      balance: 'Balance',
      value: 'Value',
      assetProportion: 'Asset Proportion',
      noData: 'No Data',
      transactionId: 'Transaction Number',
      enterTransactionId: 'Please enter transaction number',
      transactionType: 'Transaction Type',
      selectTransactionType: 'Please Select Transaction Type',
      typeTransferOut: 'Remittance Out',
      typeTransferIn: 'Remittance In',
      typeInviteReward: 'Invite Reward',
      transactionTime: 'Transaction Time',
      startDate: 'Start Date',
      endDate: 'End Date',
      search: 'search',
      transactionBalance: 'Transaction Amount',
      transactionFee: 'Transaction Fee',
      transactionStatus: 'Transaction Status',
      statusSuccess: 'Success',
      statusFailed: 'Failed',
      remark: 'Remark',
      noRemark: 'No Remark',
      operation: 'Operation',
      detail: 'Detail',
      status: 'State',
      selectStatus: 'Please select a status',
      statusRejected: 'Rejected',
      statusCompleted: 'Completed',
      statusPending: 'Pending Review',
      depositAmount: 'Deposit Amount',
      fee: 'Fee',
      feeRate: 'Fee Rate',
      actualAmount: 'Actual Amount',
      depositCurrency: 'Deposit Currency',
      depositStatus: 'Deposit Status',
      depositProof: 'Deposit Proof',
      loadFailed: 'Load Failed',
      depositTime: 'Deposit Time',
      walletAddress: 'Wallet Address',
      withdrawAmount: 'Withdraw Amount',
      combinedFee: 'Fee',
      withdrawCurrency: 'Withdraw Currency',
      statusApproved: 'Approved',
      statusCancelled: 'Cancelled',
      withdrawTime: 'Withdraw Time',
      withdrawBankNum: 'Withdraw Bank Number',
      withdrawBankName: 'Withdraw Bank Name',
      feeMethod: 'Fee Method',
      feeMethodPayee: 'Payee bears fee',
      feeMethodPayer: 'Payer bears fee',
      transactionDetail: 'Transaction Detail',
      basicInfo: 'Basic Information',
      amountInfo: 'Amount Information',
      amount: 'Amount',
      fetchAccountListFailed: 'Failed to fetch account list',
      copySuccess: 'Copy successful',
      detailDev: 'View detail feature under development'
    },
    digitalExchange: {
      title: 'Digital Asset Exchange',
      sell: 'Sell',
      buy: 'Buy',
      availableBalance: 'Available balance',
      enterQuantity: 'Please Enter Quantity',
      autoCalculate: 'Auto calculate',
      fee: 'Service Charge',
      price: 'Price',
      confirmTransaction: 'Confirm Exchange',
      exchanging: 'Exchanging...',
      return: 'Return',
      fillCompleteInfo: 'Please fill in complete information',
      tradeSuccess: 'Trade successful',
      tradeFailed: 'Trade failed',
      fetchCurrencyFailed: 'Failed to fetch currency list',
      fetchRateFailed: 'Failed to fetch exchange rate'
    },
    digitalWithdraw: {
      title: 'Transfer Out',
      withdrawWallet: 'Withdrawal Wallet',
      selectWithdrawWallet: 'Please select withdrawal wallet',
      withdrawAddress: 'Withdrawal Blockchain Wallet Address',
      selectWithdrawAddress: 'Please select withdrawal address',
      withdrawAmount: 'Withdrawal Amount',
      enterWithdrawAmount: 'Withdrawal Amount',
      withdrawAll: 'Withdraw All',
      minAmount: 'Minimum Withdrawal Amount',
      availableBalance: 'Available Balance',
      combinedFee: 'Fee',
      actualAmount: 'Actual Received Amount',
      confirmWithdraw: 'Confirm Withdrawal',
      selectWalletWarning: 'Please select withdrawal wallet',
      selectAddressWarning: 'Please select withdrawal address',
      enterAmountWarning: 'Please enter withdrawal amount',
      withdrawSuccess: 'Withdrawal submitted successfully',
      withdrawFailed: 'Withdrawal failed',
      fetchBalanceFailed: 'Failed to fetch balance',
      fetchWalletFailed: 'Failed to fetch wallet information'
    },
    digitalWithdrawal: {
      title: 'Deposit & Withdrawal Account Management',
      addWallet: 'Add New Deposit Payment Wallet',
      walletName: 'Wallet Name',
      walletAddress: 'Wallet Address',
      createTime: 'Creation Time',
      operate: 'Operate',
      delete: 'Delete',
      enterWalletName: 'Please enter wallet name',
      enterWalletAddress: 'Please enter wallet address',
      cancel: 'Cancel',
      confirm: 'Confirm',
      addSuccess: 'Added successfully',
      addFailed: 'Add failed',
      deleteConfirm: 'Confirm to delete this wallet?',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Delete failed',
      fetchWalletFailed: 'Failed to fetch wallet list',
      copySuccess: 'Copy successful'
    },
    digitalDeposit: {
      title: 'Top Up',
      depositMethod: 'Deposit Method',
      selectDepositMethod: 'Please select deposit method',
      normalDeposit: 'Ordinary deposit',
      blockchainNetwork: 'Blockchain Network',
      selectNetwork: 'Please select blockchain network',
      depositTo: 'Deposit To',
      selectCurrency: 'Please select currency',
      copyAddress: 'Please copy the following address information to recharge your wallet',
      copy: 'Copy',
      noAddress: 'No address available to copy',
      rechargeAmount: 'Recharge Amount',
      enterRechargeAmount: 'Please enter recharge amount',
      tradeId: 'Transaction ID',
      enterTradeId: 'Please enter the transaction number',
      uploadScreenshot: 'Upload Bank Transfer Screenshot',
      warning1: '*Please ensure that the wallet address you use is accurate. If the transfer address is incorrect, your funds may be permanently lost and cannot be recovered.',
      warning2: '*Please ensure that the currency you recharge isUSDC If you transfer other currencies to this address, your funds may be permanently lost and cannot be recovered.',
      fee: 'Fee',
      actualAmount: 'Actual Received Amount',
      confirmDeposit: 'Confirm Recharge',
      minAmount: 'Minimum Recharge Amount',
      enterAmountWarning: 'Please enter recharge amount',
      enterTradeIdWarning: 'Please enter transaction number',
      uploadScreenshotWarning: 'Please upload bank transfer screenshot',
      depositSuccess: 'Deposit submitted successfully',
      depositFailed: 'Deposit failed',
      copySuccess: 'Copy successful'
    },
    foreignTradeAccount: {
      title: 'Foreign trade accounts',
      apply: 'applyForeign trade accounts',
      globalTab: 'Multi-currency global collection account',
      localTab: 'Local collection account',
      hideUnavailable: 'Hide unavailable accounts',
      globalAccount: 'Global collection account',
      localAccount: 'Local collection account',
      noAccount: 'No collection account',
      accountNotice: 'Instructions on Account use',
      scopeLimitTitle: '1.Scope of use limitation',
      scopeLimitContent: 'This account is only for inter-enterprise trade (B2B) purposes. In addition, please confirm the business background information with your buyer before making payment. It is recommended that your buyer use the corporate account to remit funds as far as possible, and make a clear note (including PI number, product information, buyer information, etc.). In addition, there will be a risk of fund return in pure personal purchase payment, please note.',
      geoLimitTitle: '2.Geographical and institutional constraints',
      bannedAreas: 'Banned areas',
      bannedAreasContent: 'Russia, Belarus, Syria, Myanmar, Afghanistan, North Korea, Iran, Cuba, the Democratic Republic of Congo, Crimea, Gaza Strip, the Palestinian West Bank, and Ukraine\'s Donetsk, Luhansk, Kherson, Zaporizhzhe regions;',
      freightLimit: 'Freight restrictions',
      freightLimitContent: 'avoid using internationally sanctioned freight companies to carry goods;',
      bankLimit: 'Banking restrictions',
      bankLimitContent: 'Financial institutions on the sanctions list (including all currencies) will not be accepted.',
      auditTitle: '3 Fund audit authority and responsibility',
      auditContent: 'We and the bank reserve the right to review the funds in the account, and the user needs to cooperate to submit the proof of the source of funds (such as contract, invoice, logistics documents, etc.); After passing the examination, the settlement can be normal, if there is any doubt, the right to freeze or return the funds;',
      thirdPartyTitle: 'Third-party payment requirements',
      thirdPartyContent: 'If the paying party is not the contracted procurement subject (if the purchasing party is Company A and the actual paying party is Company B), the association certificate of A and B shall be provided, including but not limited to: equity structure certificate, entrusted payment agreement, procurement service agreement and other legal documents.',
      globalDesc: 'Global 200+regional collections (non sanctioned regions); Support 14+mainstream currency collection. The English name of the enterprise is supported as the account opening name',
      localDesc: 'Local collection is super convenient,fast to second to account intermediate bank commission as low as 0',
      openingArea: 'Area of accountopening',
      searchArea: 'Search for area of collection',
      search: 'Search',
      reset: 'Reset',
      applyBtn: 'apply',
      applyCollectionAccount: 'applyCollection account',
      payeeAccount: 'Account of payee',
      fetchFailed: 'Failed to fetch account list',
      statusDeal: 'Applying',
      statusSuccess: 'Approved',
      statusReject: 'Rejected',
      statusVerifyBack: 'Returned'
    },
    applyForeignTradeAccount: {
      title: 'applyCollection account',
      accountType: 'Account of payee',
      globalAccountTitle: 'Multi-currency global collection account',
      globalAccountDesc: 'Global 200+regional collections (non sanctioned regions); Support 14+mainstream currency collection. The English name of the enterprise is supported as the account opening name',
      localAccountTitle: 'Local collection account',
      localAccountDesc: 'Local collection is super convenient, fast to second to account intermediate bank commission as low as 0',
      openingArea: 'Area of Account Opening',
      searchArea: 'Search for Area of Collection',
      search: 'Search',
      reset: 'Reset',
      noRegionFound: 'No matching region found',
      bankList: 'Opening Bank',
      receivingArea: 'Receiving Area',
      receivingMethod: 'Payment Method',
      transactionLimit: 'Transaction Limit',
      accountName: 'Account Name',
      openingTime: 'Opening Time',
      receivingCurrency: 'Receiving Currency',
      bankCountry: 'Country',
      bankCurrency: 'Currency',
      productType: 'Product Type',
      businessType: 'Business Type',
      paymentMethod: 'Payment Method - Network',
      accountPayType: 'Payment Method - Public/Private Account',
      nameRequirement: 'VA Rule - Same Name',
      limitInfo: 'Transaction Limit - Single/Daily',
      bankCode: 'Bank Code',
      swift: 'SWIFT',
      currency: 'Currency',
      accountTypeLabel: 'Account Type',
      noData: 'No Data',
      offlineNotice: 'For collection in this region, please contact our operations staff offline.',
      nar1Title: 'Annual Return Form (NAR1)',
      nar1UploadTip: 'Please upload the Annual Return Form (NAR1) to speed up the review process. Supports JPG, JPEG, PNG, PDF formats, maximum 1 file, each file limited to 20MB',
      dragUpload: 'Click to upload, or drag and drop files here',
      materialTitle: 'Other Supplementary Materials',
      materialTooltip: 'Please upload other supplementary materials to speed up the review process. Supports JPG, JPEG, PNG, PDF formats, maximum 10 files, each file limited to 20MB',
      back: 'Back',
      apply: 'Apply',
      accountNotice: 'Instructions on Account Use',
      scopeLimitTitle: '1. Scope of Use Limitation',
      scopeLimitContent: 'This account is only for inter-enterprise trade (B2B) purposes. In addition, please confirm the business background information with your buyer before making payment. It is recommended that your buyer use the corporate account to remit funds as far as possible, and make a clear note (including PI number, product information, buyer information, etc.). In addition, there will be a risk of fund return in pure personal purchase payment, please note.',
      geoLimitTitle: '2. Geographical and Institutional Constraints',
      bannedAreas: 'Banned Areas',
      bannedAreasContent: 'Russia, Belarus, Syria, Myanmar, Afghanistan, North Korea, Iran, Cuba, the Democratic Republic of Congo, Crimea, Gaza Strip, the Palestinian West Bank, and Ukraine\'s Donetsk, Luhansk, Kherson, Zaporizhzhe regions;',
      freightLimit: 'Freight Restrictions',
      freightLimitContent: 'Avoid using internationally sanctioned freight companies to carry goods;',
      bankLimit: 'Banking Restrictions',
      bankLimitContent: 'Financial institutions on the sanctions list (including all currencies) will not be accepted.',
      auditTitle: '3. Fund Audit Authority and Responsibility',
      auditContent: 'We and the bank reserve the right to review the funds in the account, and the user needs to cooperate to submit the proof of the source of funds (such as contract, invoice, logistics documents, etc.); After passing the examination, the settlement can be normal, if there is any doubt, the right to freeze or return the funds;',
      thirdPartyTitle: 'Third-party Payment Requirements',
      thirdPartyContent: 'If the paying party is not the contracted procurement subject (if the purchasing party is Company A and the actual paying party is Company B), the association certificate of A and B shall be provided, including but not limited to: equity structure certificate, entrusted payment agreement, procurement service agreement and other legal documents.',
      selectRegionWarning: 'Please select the opening area',
      fetchCountryFailed: 'Failed to fetch country list',
      searchSuccess: 'Search successful',
      selectAccountTypeWarning: 'Please select collection account type',
      confirmSubmit: 'Are you sure you want to submit this application?',
      confirmTitle: 'Confirm Application',
      confirm: 'Confirm',
      cancel: 'Cancel',
      submitSuccess: 'Application submitted successfully, review period is usually 1-3 working days',
      submitFailed: 'Application submission failed',
      uploading: 'Uploading'
    },
    foreignTradeAccountDetail: {
      title: 'Details of the receiving account',
      globalAccount: 'Global Collection',
      localAccount: 'Local collection',
      applyTime: 'Application Time',
      openTime: 'Time opening',
      initiatePayment: 'Receive Payments',
      copyAccountInfo: 'Copy Account Information',
      downloadAccountInfo: 'DownloadAccount Information',
      capacityAccount: 'Capacity account',
      receivingArea: 'Collection area',
      receivingMethod: 'Payment method',
      transactionLimit: 'Transaction limit',
      receivingCurrency: 'Currency',
      accountInfo: 'Account Information',
      accountNo: 'Account No',
      accountName: 'Account Name',
      bankName: 'Bank Name',
      countryRegion: 'Country/Region of account',
      swiftCode: 'Swift Code',
      bankAddress: 'Bank Address',
      iban: 'IBAN',
      bsbNumber: 'BSB Number',
      branchBankName: 'Branch Bank Name',
      branchBankCode: 'Branch Bank Code',
      accountNotice: 'Instructions on Account use',
      scopeLimitTitle: '1.Scope of use limitation',
      scopeLimitContent: 'This account is only for inter-enterprise trade (B2B) purposes. In addition, please confirm the business background information with your buyer before making payment. It is recommended that your buyer use the corporate account to remit funds as far as possible, and make a clear note (including PI number, product information, buyer information, etc.). In addition, there will be a risk of fund return in pure personal purchase payment, please note.',
      geoLimitTitle: '2.Geographical and institutional constraints',
      bannedAreas: 'Banned areas',
      bannedAreasContent: 'Russia, Belarus, Syria, Myanmar, Afghanistan, North Korea, Iran, Cuba, the Democratic Republic of Congo, Crimea, Gaza Strip, the Palestinian West Bank, and Ukraine\'s Donetsk, Luhansk, Kherson, Zaporizhzhe regions;',
      freightLimit: 'Freight restrictions',
      freightLimitContent: 'avoid using internationally sanctioned freight companies to carry goods;',
      bankLimit: 'Banking restrictions',
      bankLimitContent: 'Financial institutions on the sanctions list (including all currencies) will not be accepted.',
      auditTitle: '3 Fund audit authority and responsibility',
      auditContent: 'We and the bank reserve the right to review the funds in the account, and the user needs to cooperate to submit the proof of the source of funds (such as contract, invoice, logistics documents, etc.); After passing the examination, the settlement can be normal, if there is any doubt, the right to freeze or return the funds;',
      thirdPartyTitle: 'Third-party payment requirements',
      thirdPartyContent: 'If the paying party is not the contracted procurement subject (if the purchasing party is Company A and the actual paying party is Company B), the association certificate of A and B shall be provided, including but not limited to: equity structure certificate, entrusted payment agreement, procurement service agreement and other legal documents.',
      loading: 'Loading...',
      missingId: 'Missing account ID',
      fetchFailed: 'Failed to fetch account details',
      copySuccess: 'Account information copied to clipboard',
      downloadSuccess: 'Account information downloaded',
      statusDeal: 'Applying',
      statusSuccess: 'It has been opened',
      statusReject: 'Rejected',
      statusVerifyBack: 'Returned'
    },
    kycModal: {
      title: 'Enterprise Certification',
      incomplete: 'Enterprise certification incomplete',
      desc: 'Uncertified enterprises cannot use all services provided. Complete certification in three simple steps.',
      certify: 'Certify Now'
    },
    certificationMaterial: {
      title: 'Enterprise Certification',
      activateTitle: 'ACTIVATE YOUR ACCOUNT',
      countryOfRegistration: 'Country of Registration',
      countryOfRegistrationEn: 'Country of Registration',
      mainlandChina: 'Mainland China',
      hongKong: 'Hong Kong, China',
      otherCountries: 'Other Countries/Regions',
      selectCountry: 'Please select country/region',
      requiredDocuments: 'Required Documents',
      requiredDocumentsMainland: 'Required Documents for Mainland China Enterprise Certification',
      requiredDocumentsHongkong: 'Required Documents for Hong Kong Enterprise Certification',
      requiredDocumentsOther: 'Required Documents for Other Countries/Regions Certification',
      corporateInfo: 'Corporate Information',
      enterpriseLegalPerson: 'Enterprise legal person',
      corporateShareholders: 'Corporate Shareholders',
      enterpriseDirectors: 'Enterprise Directors',
      directorsShareholders: 'Directors/shareholders of a company',
      threeInOne: 'The latest version of three certificates in one',
      businessLicense: 'Business License',
      idPortrait: 'Identification document (front side)',
      idNational: 'Identification document (back side)',
      legalPersonDesc: 'Legal representative of the enterprise/individual industrial and commercial proprietor',
      shareholderDesc: 'For each individual shareholder, please provide:',
      directorDesc: 'For each director, please provide:',
      ci: 'Certificate of Incorporation (CI)',
      br: 'Business Registration Certificate(BR)',
      nnc1: 'Incorporation Form (NNC1)',
      nar1: 'Articles of Association / Annual Return (NAR1)',
      equity: 'Shareholding Structure',
      passport: 'Passport',
      registrationCert: 'Enterprise Registration Certificate',
      continuedOperation: 'Certificate of Continued Operation (Certificate of Good Standing, Tax Certificate, previous year\'s annual review report, etc.)',
      equityStructure: 'Equity Structure (documents containing equity structure, Articles of Association, Register of Shareholders, etc.)',
      submitBtn: 'Continue to Upload',
      submitBtnEn: 'Continue to Upload',
      selectCountryWarning: 'Please select country/region',
      fetchCountryFailed: 'Failed to fetch country list',
      loadCountryFailed: 'Failed to load country list',
      ciEn: 'Certificate of Incorporation (CI)',
      brEn: 'Business Registration Certificate(BR)',
      nnc1En: 'Incorporation Form (NNC1)',
      nar1En: 'Articles of Association / Annual Return (NAR1)',
      equityEn: 'Shareholding Structure',
      directorsInfo: 'Enterprise Directors',
      directorsInfoEn: 'Directors Information',
      directorsDesc: 'For each director, please provide:',
      directorsDescEn: 'For each director, please provide:',
      shareholderDescEn: 'For each individual shareholder, please provide:',
      registrationCertEn: 'Enterprise Registration Certificate, Certificate of Continued Operation (Certificate of Good Standing, Tax Certificate, previous year\'s annual review report, etc.), Equity Structure (documents containing equity structure, Articles of Association, Register of Shareholders, etc.)',
      corporateInfoEn: 'Corporate Information',
      directorsShareholdersEn: 'Directors/shareholders of a company',
      corporateInfoEnMainland: 'Corporate Information',
      enterpriseLegalPersonEn: 'Enterprise legal person',
      corporateShareholdersEn: 'Corporate Shareholders',
      threeInOneEn: 'The latest version of three certificates in one',
      businessLicenseEn: 'Business License',
      legalPersonDescEn: 'Legal representative of the enterprise/individual industrial and commercial proprietor',
      idPortraitEn: 'Identification document (front side)',
      idNationalEn: 'Identification document (back side)',
      shareholderDescEnMainland: 'For each individual shareholder, please provide:'
    },
    overseasRemittanceAccountDetail: {
      breadcrumb: 'Overseas remittance account',
      detailTitle: 'Account Detail',
      accountBelong: 'The account belongs to',
      accountType: 'Account Type',
      companyAccount: 'Business account',
      personalAccount: 'Personal account',
      legalPerson: 'Legal person/Shareholder',
      employee: 'Employee',
      accountInfo: 'Account Information',
      bankRegion: 'Area of the bank',
      accountCurrency: 'Account Currency',
      bankAccountName: 'Bank account name',
      bankAccountNumber: 'Bank Account Number',
      bankName: 'Bank Name',
      swiftCode: 'swiftCode/BIC',
      bankAddress: 'Bank Address',
      back: 'Return',
      supplier: 'Account supplier',
      enterprise: 'Account this enterprise'
    },
    tradeOrderDetail: {
      breadcrumb: 'Bill of trade',
      detailTitle: 'Trade order detail',
      merchantOrderNo: 'Merchant Order No',
      tradeNo: 'Trade Order No',
      paymentCurrency: 'Collection Currency',
      tradeType: 'Trade type',
      contractNo: 'Contract Number',
      tradeCountry: 'Trading countries/regions',
      tradeAmount: 'Contract amount',
      associatedAmount: 'Associated amount',
      associationRatio: 'Proportion of association',
      counterparty: "Payer's English name",
      status: 'State',
      createTime: 'Date creation',
      updateTime: 'Update Time',
      rejectReason: 'Reject Reason',
      tradeMaterials: 'Trade materials',
      download: 'Download',
      backToList: 'Back to list',
      goodsTrade: 'Goods Trade',
      serviceTrade: 'Service Trade',
      invoiceContract: 'Contract/Invoice files',
      contractFiles: 'Contract files',
      piCiFiles: 'PI/CI files',
      proofMaterials: 'Supporting documents',
      otherFiles: 'Other files',
      missingId: 'Missing order ID',
      fetchFailed: 'Failed to fetch detail',
      statusInCollection: 'In collection',
      statusRejected: 'Rejected',
      statusApproved: 'Processing',
      statusUnderReview: 'Under Review',
      statusCompleted: 'Collection Completed',
      statusClosed: 'Closed down',
      relatedReceipts: 'Related Trade Receipts',
      receiptNo: 'Trade Receipt No',
      receiptDate: 'Receipt Date',
      entryDate: 'Entry Date',
      receivingAccount: 'Receiving Account',
      statusPending: 'Pending',
      statusSuccess: 'Success',
      statusReviewing: 'Under Review',
      view: 'View'
    },
    tradeReceiptDetail: {
      breadcrumb: 'Trade receipt',
      detailTitle: 'Trade receipt detail',
      orderNo: 'Trade Receipt No',
      tradeNo: 'Trade No',
      currency: 'Currency',
      orderAmount: 'Payment Amount',
      accountNo: 'Collection account',
      paymentAccountNo: 'Payer Account No',
      paymentAccountName: 'Payer Account Name',
      paymentBankName: 'Payer Bank Name',
      reference: 'Reference',
      status: 'State',
      receiptDate: 'Receipt Date',
      entryDate: 'Entry Date',
      rejectReason: 'Reject Reason',
      remark: 'Remark',
      createTime: 'Date creation',
      updateTime: 'Update Time',
      backToList: 'Back to list',
      missingId: 'Missing receipt ID',
      fetchFailed: 'Failed to fetch detail',
      statusPending: 'Pending association',
      statusReviewing: 'In process',
      statusRejected: 'Rejected',
      statusSuccess: 'Entry success',
      statusFail: 'Failed'
    },
    kycModal: {
      title: 'Enterprise Certification',
      incomplete: 'Enterprise certification incomplete',
      desc: 'Uncertified enterprises cannot use all services provided. Complete certification in three simple steps.',
      certify: 'Certify Now'
    },
    overseasRemittanceAccountDetail: {
      breadcrumb: 'Overseas remittance account',
      detailTitle: 'Account Detail',
      accountBelong: 'The account belongs to',
      accountType: 'Account Type',
      companyAccount: 'Business account',
      personalAccount: 'Personal account',
      legalPerson: 'Legal person/Shareholder',
      employee: 'Employee',
      accountInfo: 'Account Information',
      bankRegion: 'Area of the bank',
      accountCurrency: 'Account Currency',
      bankAccountName: 'Bank account name',
      bankAccountNumber: 'Bank Account Number',
      bankName: 'Bank Name',
      swiftCode: 'swiftCode/BIC',
      bankAddress: 'Bank Address',
      back: 'Return',
      supplier: 'Account supplier',
      enterprise: 'Account this enterprise'
    },
    tradeOrderDetail: {
      breadcrumb: 'Bill of trade',
      detailTitle: 'Trade order detail',
      merchantOrderNo: 'Merchant Order No',
      tradeNo: 'Trade Order No',
      paymentCurrency: 'Collection Currency',
      tradeType: 'Trade type',
      contractNo: 'Contract Number',
      tradeCountry: 'Trading countries/regions',
      tradeAmount: 'Contract amount',
      associatedAmount: 'Associated amount',
      associationRatio: 'Proportion of association',
      counterparty: "Payer's English name",
      status: 'State',
      createTime: 'Date creation',
      updateTime: 'Update Time',
      rejectReason: 'Reject Reason',
      tradeMaterials: 'Trade materials',
      download: 'Download',
      backToList: 'Back to list',
      goodsTrade: 'Goods Trade',
      serviceTrade: 'Service Trade',
      invoiceContract: 'Contract/Invoice files',
      contractFiles: 'Contract files',
      piCiFiles: 'PI/CI files',
      proofMaterials: 'Supporting documents',
      otherFiles: 'Other files',
      missingId: 'Missing order ID',
      fetchFailed: 'Failed to fetch detail',
      statusInCollection: 'In collection',
      statusRejected: 'Rejected',
      statusApproved: 'Processing',
      statusUnderReview: 'Under Review',
      statusCompleted: 'Collection Completed',
      statusClosed: 'Closed down',
      relatedReceipts: 'Related Trade Receipts',
      receiptNo: 'Trade Receipt No',
      receiptDate: 'Receipt Date',
      entryDate: 'Entry Date',
      receivingAccount: 'Receiving Account',
      statusPending: 'Pending',
      statusSuccess: 'Success',
      statusReviewing: 'Under Review',
      view: 'View'
    },
    tradeReceiptDetail: {
      breadcrumb: 'Trade receipt',
      detailTitle: 'Trade receipt detail',
      orderNo: 'Trade Receipt No',
      tradeNo: 'Trade No',
      currency: 'Currency',
      orderAmount: 'Payment Amount',
      accountNo: 'Collection account',
      paymentAccountNo: 'Payer Account No',
      paymentAccountName: 'Payer Account Name',
      paymentBankName: 'Payer Bank Name',
      reference: 'Reference',
      status: 'State',
      receiptDate: 'Receipt Date',
      entryDate: 'Entry Date',
      rejectReason: 'Reject Reason',
      remark: 'Remark',
      createTime: 'Date creation',
      updateTime: 'Update Time',
      backToList: 'Back to list',
      missingId: 'Missing receipt ID',
      fetchFailed: 'Failed to fetch detail',
      statusPending: 'Pending association',
      statusReviewing: 'In process',
      statusRejected: 'Rejected',
      statusSuccess: 'Entry success',
      statusFail: 'Failed'
    },
    overseasRemittance: {
      title: 'Overseas remittance account',
      addAccount: 'Add overseas remittance account',
      enterpriseAccount: 'Account this enterprise',
      supplierAccount: 'Account supplier',
      accountType: 'AccountType',
      selectAccountType: 'Please select Account Type',
      status: 'State',
      selectStatus: 'Please select State',
      accountNameOrNumber: 'Account name or accountnumber',
      enterAccountNameOrNumber: 'Please enterAccount name or account no',
      search: 'search',
      reset: 'Reset',
      payeeAccountName: 'Name of payee account',
      accountNumber: 'Account Number',
      accountTypeLabel: 'Account Type',
      currency: 'Currency',
      bankName: 'Bank Name',
      statusLabel: 'State',
      rejectReason: 'Reasons for Rejection',
      operation: 'Operation',
      viewDetail: 'Detail',
      edit: 'Edit',
      reapply: 'Re-submit',
      noData: 'No Data',
      companyAccount: 'Business account',
      personalAccount: 'Personal account',
      statusReviewing: 'Under Review',
      statusRejected: 'Rejected',
      statusInUse: 'In Use',
      statusClosed: 'Closed',
      statusFrozen: 'Frozen',
      enterprise: 'Enterprise',
      personal: 'Personal',
      accountBelong: 'The account belongs to',
      supplier: 'Account supplier',
      accountTypeTitle: 'Account Type',
      company: 'Business account',
      personalAccount2: 'Personal account',
      legalPerson: 'Legal representative/shareholder',
      employee: 'Employee',
      accountInfo: 'Account Information',
      bankRegion: 'Area of the bank',
      selectBankRegion: 'Please select Area of the bank',
      bankAccountName: 'Bank account name',
      enterBankAccountName: 'Please enterBank account name',
      bankNameLabel: 'Bank Name',
      enterBankName: 'Please enterBank Name',
      accountCurrency: 'Account Currency',
      selectAccountCurrency: 'Please Select the AccountCurrency',
      bankAccountNumber: 'Bank Account Number',
      enterBankAccountNumber: 'Please enterBank Account Number',
      swiftCode: 'swiftCode/BIC',
      enterSwiftCode: 'Please enterswiftCode/BIC',
      bankAddress: 'Bank Address',
      enterBankAddress: 'Please enterBank Address',
      bankAddressTip: 'Please fll in the complete English address of the bank If you do not till in the complete address the payment may fail',
      return: 'Return',
      apply: 'apply',
      submitSuccess: 'Application submitted successfully',
      submitting: 'Submitting...'
    },
    rmbSettlement: {
      title: 'RMB Settlement Withdrawal Account',
      addAccount: 'Add settlement withdrawal account',
      editAccount: 'Edit settlement withdrawal account',
      enterpriseAccount: 'This enterprise account',
      supplierAccount: 'Supplier account',
      enterpriseAccountDesc: 'The account name is the company Chinese name or the personal account of the legal representative, directors, or shareholders',
      supplierAccountDesc: 'Used for settlement with enterprise, individual suppliers or related business partners',
      accountType: 'Account type',
      selectAccountType: 'Please select',
      status: 'Status',
      selectStatus: 'Please select status',
      accountNameOrNumber: 'Account name or account number',
      enterAccountNameOrNumber: 'Please enter account name or account number',
      search: 'Search',
      payeeAccountName: 'Payee account name',
      accountNumber: 'Account number',
      accountTypeLabel: 'Account type',
      bankName: 'Bank name',
      statusLabel: 'Status',
      rejectReason: 'Rejection reason',
      operation: 'Operation',
      view: 'View',
      edit: 'Edit',
      noData: 'No data',
      personalAccount: 'Personal account',
      companyAccount: 'Enterprise account',
      statusReviewing: 'Under Review',
      statusInUse: 'In use',
      statusRejected: 'Rejected',
      statusClosed: 'Closed',
      // 详情/新增页面共用
      detail: 'Account detail',
      accountBelong: 'Account belongs to',
      legalPerson: 'Legal representative / shareholder',
      employee: 'Employee',
      accountInfo: 'Account information',
      bankAccountNumber: 'Bank account number',
      enterBankAccountNumber: 'Please enter bank account number',
      accountNumberFormat: 'Format: 6222000000000000000',
      accountNumberFormatEditSuffix: ', cannot be modified once created',
      bankNameLabel: 'Bank name',
      enterBankName: 'Please enter bank name',
      auditStatus: 'Audit status',
      returnReason: 'Rejection reason',
      createdAt: 'Created at',
      auditedAt: 'Audited at',
      branchName: 'Branch name',
      enterBranchName: 'Please enter branch name',
      cnapsCode: 'CNAPS code',
      enterCnapsCode: 'Please enter CNAPS code',
      back: 'Back',
      // 新增页面专属
      singleSubmit: 'Single submit',
      batchSubmit: 'Batch submit',
      cardholderName: 'Cardholder name',
      selectCardholderName: 'Please select cardholder name',
      enterCardholderName: 'Please enter cardholder name',
      bankAccountName: 'Bank account name',
      enterBankAccountName: 'Please enter bank account name',
      enterpriseNameAuto: 'Enterprise name is automatically filled by system',
      orangeTipPersonal: 'Account name must match the personal ID name',
      downloadTemplate: 'Download batch import template',
      uploadDragText: 'Drag file here, or',
      uploadClickText: 'click to upload',
      uploadHint: 'Only xls/xlsx files are supported, up to 1 file at a time',
      agreementPrefix: 'I have read and agree to the ',
      agreementLink: 'Authorization Commitment Letter',
      agreementSuffix: ', and confirm that the information filled in is true and accurate.',
      authorizationTitle: 'Authorization Commitment Letter',
      confirm: 'Confirm',
      submit: 'Submit',
      submitting: 'Submitting...',
      // 校验提示
      ruleSelectCardholder: 'Please select cardholder name',
      ruleEnterCardholder: 'Please enter cardholder name',
      ruleEnterAccountNumber: 'Please enter bank account number',
      ruleEnterBankName: 'Please enter bank name',
      ruleEnterAccountName: 'Please enter bank account name',
      ruleEnterBranchName: 'Please enter branch name',
      ruleEnterCnapsCode: 'Please enter CNAPS code',
      ruleBatchFileRequired: 'Please upload batch import file',
      ruleAgreementRequired: 'Please read and agree to the Authorization Commitment Letter first',
      ruleExceedFileLimit: 'Up to 1 file can be uploaded at a time, please remove the uploaded file first',
      msgTemplateDeveloping: 'Template download feature is under development',
      msgSubmitSuccess: 'Application submitted successfully',
      msgEditSuccess: 'Modified successfully',
      msgLoadFailed: 'Failed to load detail',
      msgEnterpriseInfoFailed: 'Failed to get enterprise information',
      msgSubmitFailed: 'Application submission failed, please try again later',
      msgLoading: 'Loading...',
      // 授权承诺函条款
      clause1: 'Authorize settlement to our company corporate account, or personal accounts of legal representative, directors, or shareholders who have Chinese resident identity and have a real trade relationship with our company;',
      clause2: 'For settlement to our domestic purchasing agent, we promise to conduct settlement operations based on real trade background and purchasing agency relationship. Our company confirms and guarantees that the declarant is our domestic purchasing agent, the fund settlement between our company and the declarant is real, our company has obtained the declarant explicit consent to authorize our company to submit their information to the platform partner bank for settlement declaration of settlement funds between our company and them. Our company has explicitly informed the authorized party that the name, ID number and other personal information submitted by our company will be used for declaration to the State Administration of Foreign Exchange of China. Our company further promises and guarantees that the consent and authorization of the authorized party have been obtained.',
      clause3: 'We ensure that all information submitted when using the settlement service has obtained valid authorization and continues to be within the validity period. If the authorized personnel information changes, we will promptly modify and update the relevant personnel information when using the settlement service. We understand and agree that ensuring the authenticity and validity of the submitted information is entirely our responsibility and obligation, and the platform bears no legal responsibility for this.',
      clause4: 'We ensure that the payee information filled in is accurate, and further confirm that the payee information and bank account filled in the settlement to supplier interface are our supplier and their bank account. If the payment fails or the settlement funds are paid to the wrong account due to incorrect information, all resulting losses will be borne by us, and the platform bears no legal responsibility for this.',
      clause5: 'Our company guarantees that all information stated in this commitment letter is true and valid. If our company makes any false statement or fails to obtain valid authorization, our company will bear all legal responsibilities. If any loss is caused to the platform as a result, our company will bear full compensation responsibility to ensure the platform is free from any loss.'
    },
    settlementOrder: {
      title: 'Settlement Order',
      createOrder: 'Create settlement order',
      // 状态 Tab
      tabAll: 'All',
      tabDealing: 'Settling',
      tabPartial: 'Partial success',
      tabSuccess: 'Settlement completed',
      tabFailed: 'Failed',
      // 搜索表单
      orderNo: 'Settlement order no.',
      enterOrderNo: 'Please enter settlement order no.',
      createDate: 'Created date',
      completeDate: 'Completed date',
      dateRangeSep: 'to',
      startDate: 'Start date',
      endDate: 'End date',
      settlementType: 'Settlement type',
      selectSettlementType: 'Please select',
      typeLabor: 'Labor settlement',
      typeGoods: 'Goods trade settlement',
      typeService: 'Service trade settlement',
      search: 'Search',
      // 表格
      noData: 'No data',
      colOrderNo: 'Settlement order no.',
      colCreateTime: 'Created at',
      colPayCurrency: 'Pay currency',
      colSettlementAmount: 'Settlement amount',
      colFee: 'Fee',
      colArrivalCurrency: 'Arrival currency',
      colArrivalAmount: 'Settlement arrival amount',
      colSettlementType: 'Settlement type',
      colStatus: 'Status',
      colRemark: 'Remark',
      colCompleteTime: 'Completed at',
      colOperation: 'Operation',
      view: 'View',
      paymentDetail: 'Payment detail',
      // 抽屉详情
      detailTitle: 'Settlement order detail',
      merchantOrderNo: 'Merchant order no.',
      detailOrderNo: 'Settlement order no.',
      detailSettlementType: 'Settlement type',
      detailStatus: 'Status',
      detailPayCurrency: 'Pay currency',
      detailSettlementAmount: 'Settlement amount',
      detailArrivalCurrency: 'Arrival currency',
      detailArrivalAmount: 'Settlement arrival amount',
      detailFee: 'Fee',
      detailRemark: 'Remark',
      detailCreateTime: 'Created at',
      detailCompleteTime: 'Completed at',
      failReason: 'Failure reason',
      close: 'Close',
      // 状态映射
      statusInit: 'Pending payment',
      statusDeal: 'Settling',
      statusVerifyBack: 'Audit returned',
      statusPart: 'Partial success',
      statusSuccess: 'Settlement completed',
      statusFail: 'Failed',
      // 提示
      msgGetDetailFailed: 'Failed to get order detail'
    },
    createSettlementOrder: {
      breadcrumbRoot: 'Settlement Order',
      title: 'Create settlement order',
      typeLaborTitle: 'Labor payment settlement',
      laborDesc1: 'Supports withdrawal to mainland enterprise same-name bank accounts, legal representative, shareholders holding 25% and above, suppliers and enterprise employee bank accounts',
      laborDesc2: 'Settlement operation requires submission of settlement declaration materials, which must not use previously used detail content (including other platforms)',
      laborDesc3: 'Settlement fee is (settlement amount * handling fee), no other fees',
      laborDesc4: 'Standard settlement: Processing time is next business day (excluding Hong Kong and US holidays) 9:00 to 16:00 (Beijing time)',
      laborDesc5: 'Express settlement: Processing time is 7*24 hours',
      msgTypeDeveloping: 'The creation function for "{title}" is under development'
    },
    laborSettlement: {
      // Page title & breadcrumb
      pageTitle: 'Labor payment settlement',
      createOrderTitle: 'Create settlement order',
      orderRecordBtn: 'Settlement order',
      // Steps
      stepSelectAccount: 'Select settlement account',
      stepFillInfo: 'Fill in settlement information',
      stepConfirm: 'Settlement information confirmation',
      // Select account page
      selectAccountQuestion: 'Please select settlement account(s) (multiple selection allowed)',
      emptyAccount: 'No settlement account data',
      addRmbAccount: 'Add RMB settlement account',
      nextBtn: 'Next',
      prevBtn: 'Previous',
      // Table columns
      colIndex: 'No.',
      colAccountName: 'Account name',
      colAccountNo: 'Account number',
      colBankName: 'Bank',
      colAccountType: 'Account type',
      colReceiptAmountCny: 'Receipt amount (CNY)',
      colReferenceOptional: 'Reference (optional)',
      colReference: 'Reference',
      colPayeeName: 'Payee name',
      colReceiptAccount: 'Receipt account',
      colReceiptAmount: 'Receipt amount',
      colPayerName: 'Payer name',
      colCertType: 'ID type',
      colCertNo: 'ID number',
      colBirthday: 'Date of birth',
      colRelation: 'Relationship with payee',
      // Account type
      accountTypePersonal: 'Personal account',
      accountTypeEnterprise: 'Enterprise account',
      // Placeholder
      phReceiptAmount: 'Please enter receipt amount',
      phReference: 'Please enter reference',
      phPayerName: 'Please enter payer name',
      phCertType: 'Please select ID type',
      phCertNo: 'Please enter ID number',
      phBirthday: 'Please select date of birth',
      phRelation: 'Please select relationship',
      phCurrency: 'Please select currency',
      phRemark: 'Please enter remark',
      phCaptcha: 'Please enter captcha',
      phEmailCode: 'Please enter email verification code',
      // Form labels
      labelPayerName: 'Payer name',
      labelCertType: 'ID type',
      labelCertNo: 'ID number',
      labelBirthday: 'Date of birth',
      labelRelation: 'Relationship with payee',
      labelPlatformAccount: 'Payment platform account',
      labelArrivalAmount: 'Settlement arrival amount',
      labelRemark: 'Remark (optional)',
      // ID type
      certIdCard: 'ID card',
      certPassport: 'Passport',
      // Relationship with payee
      relationSelf: 'Self',
      relationSpouse: 'Spouse',
      relationParents: 'Parents',
      relationChildren: 'Children',
      relationSiblings: 'Siblings',
      relationPaternalGrandparents: 'Paternal grandparents',
      relationMaternalGrandparents: 'Maternal grandparents',
      relationPaternalGrandchildren: 'Paternal grandchildren',
      relationMaternalGrandchildren: 'Maternal grandchildren',
      relationEmployee: 'Employee',
      relationNote: 'Only "Self" is supported when the payee account is a bank card',
      // Section titles
      payerInfoTitle: 'Payer information',
      payeeInfoTitle: 'Payee information',
      settlementInfoTitle: 'Settlement information',
      tradeVerifyTitle: 'Transaction verification',
      // Payee tab label
      payeeTabLabel: 'Payee {idx}: {name}',
      // Balance & rate
      availableBalance: 'Available balance: ',
      rateLabelCurrent: 'Current rate: ',
      rateLabelSettlement: 'Settlement amount: ',
      rateLabelArrival: 'Settlement arrival amount: ',
      countdownExpired: 'Expired',
      // Settlement info descriptions
      descPayCurrency: 'Payment currency',
      descRate: 'Exchange rate',
      descSettlementAmount: 'Settlement amount',
      descArrivalAmount: 'Settlement arrival amount',
      descRemark: 'Remark',
      // Verification code
      labelCaptcha: 'Captcha',
      labelEmailCode: 'Email verification code',
      getCaptcha: 'Click to get',
      getCode: 'Get code',
      resendCode: 'Resend in {sec}s',
      // Submit buttons
      submitBtn: 'Submit',
      submittingBtn: 'Submitting...',
      // Validation & messages
      msgSelectAccount: 'Please select at least one settlement account',
      msgInputReceiptAmount: 'Please enter the receipt amount of {name}',
      msgPayerNameRequired: 'Payee {idx}: Please fill in the payer name',
      msgPayerCertTypeRequired: 'Payee {idx}: Please select ID type',
      msgPayerCertNoRequired: 'Payee {idx}: Please fill in the ID number',
      msgPayerRelationRequired: 'Payee {idx}: Please select the relationship with payee',
      msgSelectCurrency: 'Please select payment currency',
      msgSelectAccountFirst: 'Please select a settlement account first',
      msgFillInfoFirst: 'Please fill in the settlement information first',
      msgDataAbnormal: 'Data abnormal, please refill',
      msgBalanceInsufficient: 'Insufficient platform account balance, available balance {balance} {currency}',
      msgInputCaptchaFirst: 'Please enter the captcha first',
      msgEmailCodeSent: 'Email verification code has been sent',
      msgInputCaptcha: 'Please enter the captcha',
      msgInputEmailCode: 'Please enter the email verification code',
      msgSubmitLoading: 'Submitting...',
      msgSubmitSuccess: 'Order submitted successfully',
      msgSubmitSuccessWithNo: 'Order submitted successfully, order number: {orderNo}',
      msgSubmitFailed: 'Submission failed, please try again later'
    },
    withdrawOrder: {
      // Page title & breadcrumb
      breadcrumbOrder: 'Settlement Order',
      pageTitle: 'Settlement Withdrawal Order',
      // Order info
      infoOrderNo: 'Settlement order no.: ',
      infoMerchantOrderNo: 'Merchant order no.: ',
      infoOrderStatus: 'Order status: ',
      // Status Tab
      tabAll: 'All',
      tabRemitInit: 'Pending withdrawal',
      tabRemitDeal: 'Withdrawing',
      tabRemitSuccess: 'Withdrawal successful',
      tabReturned: 'Returned',
      // Search form
      filterOrderNo: 'Settlement order no. / Withdrawal order no.',
      filterAccountName: 'Payee account name',
      filterAccountNumber: 'Payee account number',
      filterSettlementType: 'Withdrawal type',
      filterCreateDate: 'Created date',
      filterCompleteDate: 'Completed date',
      phInput: 'Please enter',
      phSelect: 'Please select',
      dateRangeSep: 'to',
      startPh: 'Start time',
      endPh: 'End time',
      typeLabor: 'Labor settlement',
      typeGoods: 'Goods trade settlement',
      typeService: 'Service trade settlement',
      searchBtn: 'Search',
      downloadBtn: 'Download',
      // Table
      noData: 'No withdrawal orders',
      colIndex: 'No.',
      colMerchantRemitOrderNo: 'Merchant withdrawal order no.',
      colOrderNo: 'Settlement order no.',
      colAccountName: 'Payee account name',
      colAccountNumber: 'Payee account number',
      colBankName: 'Payee bank',
      colArrivalAmount: 'Settlement arrival amount',
      colSettlementType: 'Withdrawal type',
      colStatus: 'Status',
      colReference: 'Reference',
      colCreateTime: 'Created at',
      colCompleteTime: 'Completed at',
      // Order status mapping
      orderStatusInit: 'Pending payment',
      orderStatusDeal: 'Settling',
      orderStatusVerifyBack: 'Audit returned',
      orderStatusPart: 'Partial success',
      orderStatusSuccess: 'Settlement completed',
      orderStatusFail: 'Failed',
      // Withdrawal status mapping
      remitStatusInit: 'Pending withdrawal',
      remitStatusDeal: 'Withdrawing',
      remitStatusSuccess: 'Withdrawal successful',
      remitStatusReturned: 'Returned',
      // Messages
      msgGetListFailed: 'Failed to get withdrawal order list',
      msgDownloadPending: 'Download API pending backend; export params same as query (except page/page_size)'
    },
    accountSecurity: {
      title: 'Account and security settings',
      bindPhone: 'Binding mobile phone',
      bindEmail: 'Bound emai',
      updatePhone: 'Replace bound mobile phone',
      updateEmail: 'Change bound email',
      loginPassword: 'Login password',
      passwordSet: 'Set',
      updatePassword: 'modifyLogin password',
      phoneComplianceTip: 'To ensure your account security and compliance with bank regulations, please ensure themobile number belongs to key members of the enterprise. Key members include: legalrepresentative, actual controller, natural person shareholder with over 25% equity,authorized person, etc.',
      originalPhone: 'Original Mobile Number',
      newPhone: 'New Mobile Number',
      smsCode: 'SMS verification code',
      currentPassword: 'Current Login Password',
      return: 'return',
      submit: 'Submit',
      verifyOriginalEmail: 'Verify current email',
      bindNewEmail: 'Bind new email',
      confirmModify: 'Confirm',
      emailComplianceTip: 'To ensure your account security and compliance with bank regulations, please ensure the email address belongs to a key member of the enterprise. Key members include: legal representative, actual controller, natural person shareholder with over 25% equity, authorized person, etc',
      originalEmail: 'Current email',
      emailCode: 'Email verification code',
      enterEmailCode: 'Please enterEmail verification code',
      getCode: 'Get Code',
      next: 'Next',
      modifyPassword: 'modifyLogin password',
      enterCurrentPassword: 'Please enterCurrent Login Password',
      forgotPassword: 'Forgot Password',
      newPassword: 'New Login Password',
      enterNewPassword: 'Please enterNew Login Password',
      passwordRequirements: 'passwords must meet the following conditions',
      passwordLength: '6-20 characters',
      passwordEnglish: 'contains English characters',
      passwordUpper: 'contains uppercase letters',
      passwordNumber: 'include numbers',
      confirmNewPassword: 'Confirm New Login Password',
      enterConfirmPassword: 'Please enterNew Login Password'
    },
    referralLink: {
      title: 'Exclusive Referral Link',
      description: 'One-click copy of your exclusive link to invite customers to register as Paymmt members',
      copy: 'Copy Link',
      copySuccess: 'Copy successful',
      copyFailed: 'Copy failed',
      noLink: 'No referral link available'
    },
    enterpriseBasicInfo: {
      certification: 'Enterprise Certification',
      corporateInfo: 'Corporate Information',
      legalPersonInfo: 'Legal person (Director)/shareholder information',
      tradeInfo: 'Information on Trade',
      businessLicense: 'Business License',
      uploadBusinessLicense: 'Please upload business license',
      principalType: 'Principal Type',
      principalTypeHelp: 'Company includes: limited liability company (sole proprietorship by natural person, natural person investment or holding, non-natural person investment or holding legal person sole proprietorship, etc.) and joint stock limited company; Individual businesses include: individual businesses, individual households, non-legal-person commercial entities',
      company: 'Company',
      individualBusiness: 'Individual businesses',
      companyNameZh: 'Company Name',
      enterCompanyNameZh: 'Please enterCompany name in Chinese',
      companyNameEn: 'Company name in English',
      companyNameEnHint: '(The name will be used as the name of the collection account)',
      enterCompanyNameEn: 'Please enterCompany name in English',
      creditCode: 'Business License No',
      enterCreditCode: 'Please enterBusiness License No',
      validityPeriod: 'Validity period of enterprise certificate',
      certValidityPeriod: 'Validity period of enterprise certificate',
      pleaseSelect: 'Please select',
      longTerm: 'long-term',
      selectValidityPeriod: 'Please select the validity period of enterprise certificate',
      selectEndDate: 'Please select end date',
      pleaseUpload: 'Please upload',
      registeredAddress: 'Registered address',
      selectProvince: 'Please select Province/state/territory',
      selectCity: 'Please select City/Region',
      enterDetailAddress: 'Please enterDetailed address (specific to district and County Street building number and hous)',
      selectRegisteredAddress: 'Please select registered address',
      physicalAddress: 'Physical address',
      sameAsRegistered: 'The same as the registered address of the enterprise',
      differentFromRegistered: 'Different from the registered address of the enterprise',
      fillCompleteAddress: 'Please fill in the complete physical address',
      addressProof: 'Proof of actual business address',
      uploadAddressProof: 'Please upload proof of actual business address',
      temporaryStorage: 'Temporary storage',
      return: 'return',
      next: 'Next',
      savedSuccess: 'Information has been temporarily saved',
      businessLicenseExample: 'Business License Example',
      addressProofExample: 'Proof of actual business address Example',
      fetchProvinceFailed: 'Failed to fetch province list',
      fetchCityFailed: 'Failed to fetch city list'
    },
    enterpriseBasicInfoHK: {
      ci: 'Certificate of Incorporation (CI)',
      ciExample: 'Certificate of Incorporation Example',
      companyRegNumber: 'Company Registration Number',
      enterCompanyRegNumber: 'Please enter Company Registration Number',
      hongkong: 'Hong Kong, China',
      taxBr: 'Tax Certificate or Business Registration Certificate,etc',
      taxBrExample: 'Tax Certificate or Business Registration Certificate Example',
      taxNumber: 'Taxpayer Identification No or Business Registration Certificate No,etc',
      enterTaxNumber: 'Please enter Taxpayer Identification No or Business Registration Certificate No,etc',
      taxBrValidity: 'Validity period of tax certificate or business registration certificate',
      to: 'to',
      equity: 'Company Shareholding Structure',
      equityExample: 'Company Shareholding Structure Example',
      nar1: 'Articles of Association / Annual Return (NAR1)',
      nar1Example: 'Annual Return (NAR1) Example',
      nnc1: 'Incorporation Form (NNC1)',
      nnc1Example: 'Incorporation Form (NNC1) Example',
      selectCertValidity: 'Please select the validity period of enterprise certificate or check long-term'
    },
    enterpriseBasicInfoOther: {
      registrationCert: 'Registration Certificate',
      registrationCertExample: 'Registration Certificate Example',
      continuedOperation: 'Certificate of Continued Operation',
      continuedOperationExample: 'Certificate of Continued Operation Example',
      documentNumber: 'Certificate Document No',
      enterDocumentNumber: 'Please enterCertificate Document No',
      certValidityPeriod: 'Certificate Document Validity Period',
      equityStructure: 'Equity Structure Certificate',
      equityStructureExample: 'Equity Structure Certificate Example',
      addressProof: 'Proof of actual business address',
      addressProofExample: 'Proof of actual business address Example',
      selectRegion: 'Please select Region',
      selectCity: 'Please select City/Region',
      enterDetailAddress: 'Please enterDetailed address',
      sameAsRegistered: 'The same as the registered address of the enterprise',
      differentFromRegistered: 'Different from the registered address of the enterprise',
      pleaseUpload: 'Please upload',
      pleaseEnterCompanyNameZh: 'Please enterCompany name in Chinese',
      pleaseEnterCompanyNameEn: 'Please enterCompany name in English',
      pleaseEnterCompanyRegNumber: 'Please enterCompany Registration Number',
      selectCertValidity: 'Please select the validity period of enterprise certificate or check long-term',
      selectDocValidity: 'Please select the Certificate Document Validity Period or check long-term',
      fetchProvinceFailed: 'Failed to fetch province list',
      fetchCityFailed: 'Failed to fetch city list'
    },
    enterpriseShareholder: {
      breadcrumb: 'Enterprise Certification',
      legalPersonInfo: 'Director/Shareholder Information',
      tradeInfo: 'Information on Trade',
      corporateInfo: 'Corporate Information',
      legalPersonTitle: 'Corporate Legal Person Information',
      legalShareholderIdentity: 'Director shareholder identity',
      enterpriseLegalPerson: 'Enterprise Legal Person',
      majorityShareholder: '(≥25%) and above shareholder',
      shareRatio: 'Shareholding ratio',
      enterShareRatio: 'Please enter a number between 0 and 100Shareholding ratio',
      enterShareRatioError: 'Please enter shareholding ratio',
      idType: 'ID type',
      idCard: 'ID card',
      passport: 'Passport',
      selectIdType: 'Please select ID type',
      idRegion: 'Region of certificate',
      selectIdRegion: 'Please select Region of certificate',
      selectIdRegionError: 'Please select Region of certificate',
      idFront: 'Identification document (front side)',
      idBack: 'Identification document (back side)',
      uploadIdFront: 'Please upload Identification document (front side)',
      uploadIdBack: 'Please upload Identification document (back side)',
      legalName: 'Legal person name',
      enterLegalName: 'Please enter legal person name',
      enterLegalNameError: 'Please enter legal person name',
      idNumber: 'ID number',
      enterIdNumber: 'Please enter ID number',
      enterIdNumberError: 'Please enter ID number',
      birthDate: 'Date of birth',
      selectBirthDate: 'Please select date of birth',
      selectBirthDateError: 'Please select date of birth',
      expireDate: 'Certificate expiry date',
      selectExpireDate: 'Please select certificate expiry date or check long-term',
      selectExpireDateError: 'Please select certificate expiry start date',
      selectEndDateOrLongTerm: 'Please select certificate expiry end date or check long-term',
      address: 'Actual residential address',
      selectCountry: 'Please select country',
      selectCountryError: 'Please select country',
      selectProvince: 'Please select province',
      selectProvinceError: 'Please select province',
      selectCity: 'Please select city',
      selectCityError: 'Please select city',
      enterDetailAddress: 'Please enter detailed address (specific to district, street, building number)',
      enterDetailAddressError: 'Please enter detailed address',
      passportPhoto: 'Passport',
      uploadPassport: 'Please upload passport',
      addressProof: 'Shareholder address proof',
      addressProofTooltip: 'Utility bill, bank statement or passport with address',
      uploadAddressProof: 'Please upload shareholder address proof',
      directorTitle: 'Corporate Director Information',
      directorInfo: 'Director information',
      directorShareholderIdentity: 'Director shareholder identity',
      enterpriseDirector: 'Corporate Director',
      directorName: 'Director name',
      enterDirectorName: 'Please enter director name',
      addDirector: 'Add director information',
      delete: 'Delete',
      shareholderTitle: 'Shareholder information',
      shareholderSubtitle: '(≥25%) and above shareholders',
      shareholderTooltip: 'If there is no shareholder with 25% or more shares, please provide the actual controller information',
      addShareholder: 'Add shareholder',
      addShareholderRequired: 'Please add at least one shareholder',
      shareholderName: 'Shareholder name',
      enterShareholderName: 'Please enter shareholder name',
      idPhoto: 'ID Photo',
      uploadIdPhoto: 'Please upload ID Photo',
      authorizedPersonTitle: 'Corporate Authorized Person Information',
      addAuthorizedPerson: 'Add Authorized Person',
      newAuthorization: 'New Authorization',
      authorizedName: 'Authorized person name',
      enterAuthorizedName: 'Please enter authorized person name',
      authorizationLetter: 'Corporate Authorization Letter',
      uploadAuthorizationLetter: 'Please upload corporate authorization letter',
      downloadTemplate: 'Click to download corporate authorization letter template',
      temporaryStorage: 'Temporary storage',
      return: 'return',
      next: 'Next',
      savedSuccess: 'Information saved temporarily',
      selectCountryRegion: 'Please select country/region',
      selectProvinceState: 'Please select province/state/region',
      selectCityRegion: 'Please select city/region',
      enterDetailAddress2: 'Please enter detailed address (specific to district, street, building number)',
      selectCountryRegionError: 'Please select country/region',
      selectProvinceStateError: 'Please select province/state/region',
      selectCityRegionError: 'Please select city/region',
      enterDetailAddress2Error: 'Please enter detailed address',
      selectAddressCountry: 'Please select country/region',
      selectAddressProvince: 'Please select province/state/region',
      selectAddressCity: 'Please select city/region'
    },
    enterpriseTrade: {
      breadcrumb: 'Enterprise Certification',
      tradeInfo: 'Information on Trade',
      corporateInfo: 'Corporate Information',
      legalPersonInfo: 'Director/Shareholder Information',
      identityType: 'Identity type',
      trader: 'I am a trader',
      licensedInstitution: 'I am a licensed institution',
      selectIdentityType: 'Please select identity type',
      institutionalQualification: 'Institutional qualification information',
      financialLicense: 'Financial license',
      uploadFinancialLicense: 'Please upload financial license',
      amlQuestionnaire: 'Anti-money laundering questionnaire',
      uploadAmlQuestionnaire: 'Please upload anti-money laundering questionnaire',
      amlPolicy: 'Anti-money laundering policy document',
      uploadAmlPolicy: 'Please upload anti-money laundering policy document',
      tradeInfoTitle: 'Information on Trade',
      tradeType: 'Type trade',
      selectTradeType: 'Please select trade type',
      serviceCategory: 'Service category',
      selectServiceCategory: 'Please select service category',
      ecommercePlatform: 'E-commerce platform',
      selectEcommercePlatform: 'Please select e-commerce platform',
      mainProduct: 'Main product',
      selectMainProduct: 'Please select main product',
      businessUrl: 'Operating website or APP download address',
      enterBusinessUrl: 'Please enter operating website or APP download address',
      enterBusinessUrlError: 'Please enter operating website or APP download address',
      estimatedAnnualVolume: 'Estimated annual transaction amount (USD)',
      enterEstimatedAnnualVolume: 'Please enter estimated annual transaction amount (USD)',
      enterEstimatedAnnualVolumeError: 'Please enter estimated annual transaction amount',
      lastYearVolume: 'Transaction amount of the previous year (USD)',
      enterLastYearVolume: 'Please enter transaction amount of the previous year (USD)',
      enterLastYearVolumeError: 'Please enter transaction amount of the previous year',
      mainMarkets: 'Main countries and regions where the company operates',
      selectMainMarkets: 'Please select main countries and regions where the company operates',
      selectMainMarketsError: 'Please select main countries and regions where the company operates',
      warningNote: 'Note: The platform services do not involve these countries: Afghanistan, Albania, Belarus, Bosnia and Herzegovina, the Central African Republic, Cuba, the Democratic Republic of the Congo (DRC), Ethiopia, Haiti, Iran, Iraq, Lebanon, Libya, Myanmar, Nicaragua, the Democratic People\'s Republic of Korea (DPRK), the Russian Federation, Somalia, South Sudan, Sudan, Syria, Ukraine, Venezuela, Yemen, Islamic State of Iraq and the Levant (ISIL/Daesh), Al-Qaeda, the Taliban, Montenegro, Serbia, the Gaza Strip and Pakistan. Operations are prohibited in all the above-listed countries and regions.',
      uploadOtherMaterials: 'Upload other materials',
      temporaryStorage: 'Temporary storage',
      return: 'return',
      submit: 'Submit',
      submitting: 'Submitting, please wait...',
      submitSuccess: 'Submit successfully',
      submitSuccessMessage: 'Enterprise certification application has been submitted, we will complete the review within 1-3 working days',
      confirm: 'Confirm',
      savedSuccess: 'Information saved temporarily',
      amountFormatError: 'The format of estimated annual transaction amount is incorrect, at most two decimal places',
      lastYearAmountFormatError: 'The format of transaction amount of the previous year is incorrect, at most two decimal places',
      selectMainMarketsWarning: 'Please select main countries and regions where the company operates',
      submitFailed: 'Submit failed',
      submitFailedMessage: 'Enterprise certification submission failed, please try again later'
    },
    register: {
      title: 'Create Your Paymmt Account',
      hasAccount: 'Already have an account?',
      login: 'Login',
      companyLocation: 'Where is your company headquartered?',
      email: 'Email',
      verifyCode: 'Verification code',
      sendCode: 'Send code',
      companyName: 'Company Full Name',
      password: 'Please enter password (6-20 digits+letters)',
      confirmPassword: 'Please enter password (6-20 digits+letters)',
      agree: 'I have read and agree to',
      userAgreement: 'User Agreement',
      and: 'and',
      privacyPolicy: 'Privacy Policy',
      submit: 'Register Now',
      selectLocation: 'Please select company headquarters location',
      enterEmail: 'Please enter email',
      emailFormat: 'Please enter a valid email address',
      enterVerifyCode: 'Please enter verification code',
      enterCompanyName: 'Please enter company full name',
      enterPassword: 'Please enter password',
      passwordLength: 'Password must be at least 6 characters',
      agreeTerms: 'Please agree to the User Agreement and Privacy Policy',
      enterEmailFirst: 'Please enter email first',
      emailInvalid: 'Invalid email format, please enter a valid email address',
      sending: 'Sending...',
      codeSent: 'Verification code has been sent to your email',
      registering: 'Registering...',
      registerSuccess: 'Registration successful, please login',
      registerFailed: 'Registration failed',
      mainlandChina: 'Mainland China',
      hongKong: 'Hong Kong',
      otherRegion: 'Other regions',
      chinese: '中文',
      english: 'English',
      passwordRequirements: 'Password must meet the following conditions',
      passwordLengthTip: '6-20 characters',
      passwordEnglishTip: 'Contains English characters',
      passwordNumberTip: 'Contains numbers'
    },
    fileUpload: {
      viewExample: 'View Example',
      uploadText: 'Upload, Drag the uploaded file here',
      fileTypeHint: 'Note: support jpeg/jpg/png/pdf format, with a size of within 20M',
      clickToPreview: 'Click to enlarge preview',
      imagePreview: 'Image Preview',
      fileSizeExceed: 'File size cannot exceed 20MB',
      onlySupportFormats: 'Only support JPG, PNG, JPEG, PDF formats',
      uploadSuccess: 'Upload successful',
      uploadFailed: 'Upload failed',
      deleteSuccess: 'File deleted'
    },
    legalAccount: {
      title: 'Legal Currency Account',
      totalAssetLabel: 'Total Asset Estimate',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      addBankAccount: 'Add Bank Account',
      depositProcessing: 'Deposit Processing',
      withdrawProcessing: 'Withdrawing Asset',
      availableBalance: 'Available Balance',
      accountList: 'Account List',
      transactionDetails: 'Transaction Details',
      depositRecords: 'Deposit Records',
      withdrawRecords: 'Withdrawal Records',
      currency: 'Currency',
      balance: 'Balance',
      value: 'Value',
      assetProportion: 'Asset Proportion',
      transactionId: 'Transaction Number',
      transactionType: 'Transaction Type',
      transactionTime: 'Transaction Time',
      transactionBalance: 'Transaction Amount',
      transactionFee: 'Fee',
      transactionStatus: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      detail: 'Detail',
      search: 'Search',
      enterTransactionId: 'Please enter transaction number',
      selectTransactionType: 'Please select transaction type',
      startDate: 'Start Date',
      endDate: 'End Date',
      typeTransferOut: 'Remittance Out',
      typeTransferIn: 'Remittance In',
      status: 'Status',
      selectStatus: 'Please select status',
      statusSuccess: 'Success',
      statusFailed: 'Failed',
      statusCompleted: 'Completed',
      statusPending: 'Pending Review',
      statusRejected: 'Rejected',
      statusApproved: 'Approved',
      statusCancelled: 'Cancelled',
      depositAmount: 'Deposit Amount',
      fee: 'Fee',
      feeRate: 'Fee Rate',
      actualAmount: 'Actual Amount',
      depositCurrency: 'Deposit Currency',
      depositStatus: 'Deposit Status',
      depositTime: 'Deposit Time',
      walletAddress: 'Wallet Address',
      withdrawAmount: 'Withdrawal Amount',
      combinedFee: 'Fee',
      withdrawCurrency: 'Withdrawal Currency',
      withdrawTime: 'Withdrawal Time',
      withdrawBankNum: 'Withdraw Bank Number',
      withdrawBankName: 'Withdraw Bank Name',
      feeMethod: 'Fee Method',
      feeMethodPayee: 'Payee bears fee',
      feeMethodPayer: 'Payer bears fee',
      noRemark: 'No Remark',
      copySuccess: 'Copied successfully',
      copyFailed: 'Copy failed'
    },
    legalWithdraw: {
      back: 'Back',
      title: 'Withdraw',
      receiveCurrency: 'Receive Currency',
      selectCurrency: 'Please select receive currency',
      withdrawBank: 'Transfer Bank',
      selectBank: 'Please select transfer bank',
      feeMethod: 'Fee Method',
      selectFeeMethod: 'Please select fee method',
      feeEach: 'Each bears',
      feeSender: 'Sender bears',
      feeReceiver: 'Receiver bears',
      withdrawAmount: 'Transfer Amount',
      enterAmount: 'Please enter transfer amount',
      allOut: 'All Out',
      combinedFee: 'Fee',
      actualAmount: 'Actual Amount',
      confirm: 'Confirm',
      submitSuccess: 'Withdrawal submitted successfully',
      submitFailed: 'Withdrawal submission failed'
    },
    bankAccount: {
      title: 'Bank Account',
      refresh: 'Refresh',
      addBank: 'Add Bank Card',
      editBank: 'Edit Bank Card',
      bankName: 'Bank Name',
      bankNumber: 'Bank Number',
      bankIfsc: 'SWIFT Code',
      legalName: 'Legal Name',
      countryName: 'Country',
      bankCity: 'Bank City',
      bankAddress: 'Bank Address',
      receiveCurrency: 'Receive Currency',
      currency: 'Currency',
      selectCurrency: 'Please select currency',
      enterCurrency: 'Please enter currency',
      createTime: 'Create Time',
      operation: 'Operation',
      edit: 'Edit',
      detail: 'Detail',
      bankDetail: 'Bank Card Detail',
      delete: 'Delete',
      deleteConfirm: 'Are you sure to delete this bank account?',
      warning: 'Warning',
      confirm: 'Confirm',
      cancel: 'Cancel',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed',
      cancelDelete: 'Delete cancelled',
      enterBankName: 'Please enter bank name',
      enterBankNumber: 'Please enter bank number',
      enterSwiftCode: 'Please enter SWIFT code',
      enterLegalName: 'Please enter legal name',
      selectCountry: 'Please select',
      enterBankCity: 'Please enter bank city',
      enterBankAddress: 'Please enter bank address',
      addSuccess: 'Added successfully',
      editSuccess: 'Edited successfully',
      submitFailed: 'Submit failed'
    }
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',
  silentTranslationWarn: false,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js